/* ── restauración de scroll propia ──
   La automática del navegador falla justo en #galeria: calcula la posición ANTES
   de que este script rellene #gallery-grid (que arranca vacío en el HTML servido),
   así que la mide sobre una página mucho más corta que la real. Si además la
   galería estaba desplegada, esa página vieja era además más ALTA de lo que será
   la nueva (fotos barajadas de nuevo, otra vez colapsada) — el resultado es un
   salto a una sección que no es la que se dejó.
   En vez de parchear esa restauración, se sustituye entera por una propia:
     - guarda scrollY y si #galeria estaba en pantalla, justo antes de salir de
       la página. Con `pagehide` en vez de `beforeunload`: hace lo mismo pero sin
       desactivar la caché de retroceso (bfcache) del navegador, que es lo que
       pasa con `beforeunload` en Chrome.
     - caso general (cualquier página): se restaura el scrollY guardado aquí
       mismo, apenas carga el script — estas páginas no tienen contenido que
       cambie de alto entre una carga y otra, así que no hace falta esperar.
     - caso #galeria: no tiene sentido restaurar el píxel exacto (las fotos y el
       alto cambian en cada carga) — se manda al inicio de esa sección en vez del
       punto exacto. Solo #galeria existe en la home, así que esa parte vive en
       su propio IIFE (más abajo), cuando el grid ya está pintado y medido;
       aquí solo se deja la decisión tomada en `window._wwScrollRestore` para
       que ese bloque la lea sin tener que volver a tocar sessionStorage. */
if('scrollRestoration' in history) history.scrollRestoration = 'manual';
window.addEventListener('pagehide', () => {
  try{
    const gal = document.getElementById('galeria');
    let inGallery = false;
    if(gal){
      const r = gal.getBoundingClientRect();
      inGallery = r.top < window.innerHeight && r.bottom > 0;
    }
    sessionStorage.setItem('ww-scrollY', String(window.scrollY));
    sessionStorage.setItem('ww-in-gallery', inGallery ? '1' : '0');
  }catch(e){}
});
(function(){
  let inGallery = false, savedY = null;
  try{
    inGallery = sessionStorage.getItem('ww-in-gallery') === '1';
    savedY = sessionStorage.getItem('ww-scrollY');
    sessionStorage.removeItem('ww-in-gallery');
    sessionStorage.removeItem('ww-scrollY');
  }catch(e){}
  window._wwScrollRestore = { inGallery, savedY };
  if(!inGallery && savedY !== null) window.scrollTo(0, parseInt(savedY, 10));
})();


/* ── activar la hoja de Google Fonts (patrón loadCSS: print → all) ──
   El <link> vive en el <head> con media="print" y antes llevaba onload="this.media='all'"
   inline para dejar de bloquear el render mientras carga. Bajo la CSP real (`script-src`
   sin 'unsafe-inline'), ese manejador inline queda bloqueado y el media nunca cambia a
   'all' — la hoja se queda "impresora únicamente" para siempre y el sitio cae en las
   tipografías de sistema. Solo se veía en el sitio desplegado: el servidor de desarrollo
   local no aplica `_headers`, así que ahí el bug era invisible. Con la hoja ya
   precargada (rel=preload), `link.sheet` suele estar listo para cuando llega este script,
   así que activamos ambos casos. */
(function(){
  const link = document.getElementById('gfonts-link');
  if(!link) return;
  function activar(){ link.media = 'all'; }
  if(link.sheet) activar();
  else link.addEventListener('load', activar, {once:true});
})();

/* ── analítica ───────────────────────────────────────────────────────────────
   Capa propia por encima del proveedor. Los puntos de medida llaman a wwTrack(),
   nunca a Umami directamente: cambiar de herramienta es tocar solo esta función
   en vez de veinte sitios repartidos por el fichero.
   El script del proveedor va con defer y además puede bloquearlo una extensión,
   así que los eventos que lleguen antes se guardan en cola y se envían cuando
   aparece. Si no aparece nunca, se descartan en silencio: la analítica no puede
   ser jamás el motivo de que algo de la web deje de funcionar.
   ───────────────────────────────────────────────────────────────────────────── */
(function(){
  const cola=[];
  function enviar(n,d){
    if(window.umami && typeof window.umami.track==='function'){
      try{ window.umami.track(n,d); }catch(_){}
      return true;
    }
    return false;
  }
  window.wwTrack=function(n,d){
    if(!enviar(n,d||{}) && cola.length<40) cola.push({n:n,d:d||{}});
  };
  let intentos=0;
  const reloj=setInterval(()=>{
    while(cola.length && enviar(cola[0].n,cola[0].d)) cola.shift();
    if(++intentos>20) clearInterval(reloj);       /* 10 s y se deja de esperar */
  },500);
})();

/* ── procedencia de la visita ────────────────────────────────────────────────
   Se lee la URL de entrada UNA vez y se guarda EN MEMORIA, no en localStorage ni
   en sessionStorage. Es deliberado: cualquier almacenamiento en el dispositivo que
   no sea estrictamente necesario para el servicio cae bajo el art. 22.2 de la LSSI
   y obligaría a un banner de consentimiento — justo lo que esta web ha decidido no
   tener. Con esto se pierde la atribución entre sesiones y se conserva la de la
   sesión, que es la que cubre el caso normal: clic en anuncio, aterrizaje, envío.
   ───────────────────────────────────────────────────────────────────────────── */
const WW_FUENTE=(function(){
  const p=new URLSearchParams(location.search);
  const f={};
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid']
    .forEach(k=>{ const v=p.get(k); if(v) f[k]=v.slice(0,120); });
  const ref=document.referrer||'';
  if(ref && ref.indexOf(location.host)===-1){
    try{ f.referente=new URL(ref).hostname; }catch(_){ }
  }
  return f;
})();

/* ── agenda de llamadas ──────────────────────────────────────────────────────
   Vía del lead ya decidido: en vez de pedirle una muestra gratis que le retrasa,
   agenda veinte minutos. El presupuesto y la dirección creativa se sacan hablando,
   no en un desplegable — nadie escribe su presupuesto real en un <select>.
   Se abre en pestaña nueva a propósito: incrustar Cal.com metería cookies de un
   tercero en este dominio y obligaría a revisar la política que acabamos de dejar
   sin banner. Para alguien que ya ha decidido agendar, cambiar de pestaña no frena.
   Si algún día hay que desactivarla, basta con vaciar la constante: los botones
   caen solos al correo en lugar de quedarse muertos.
   ───────────────────────────────────────────────────────────────────────────── */
const CAL_URL = 'https://cal.com/worldwork/discoverycall';
(function(){
  const enlaces = document.querySelectorAll('[data-agenda]');
  if(!enlaces.length) return;
  const respaldo = 'mailto:worldisaiagency@gmail.com'
    + '?subject=' + encodeURIComponent('Quiero una propuesta — WORLDWORK')
    + '&body='    + encodeURIComponent('Hola, somos ...\nNuestra web o Instagram: \nQué necesitamos: \nCuándo lo necesitamos: ');
  const AVISO_TAB = { es:' (se abre en una pestaña nueva)', en:' (opens in a new tab)' };
  /* El enlace nunca avisaba de que cambia de pestaña — nadie lo pedía hasta que
     alguien con lector de pantalla llegaba a Cal.com sin haber elegido salir del
     sitio. sr-only: no toca el texto visible, solo lo que se anuncia.
     Expuesta como window.wwRenderAgendaAviso porque setLang() la llama al cambiar
     de idioma — mismo patrón que wwRenderMotionLabel un poco más abajo en este
     fichero. Sin esto, cambiar a inglés habría dejado el aviso en español. */
  function renderAvisoTab(){
    const texto = AVISO_TAB[document.documentElement.lang === 'en' ? 'en' : 'es'];
    enlaces.forEach(a=>{
      let aviso = a.querySelector('.ww-tab-aviso');
      if(CAL_URL){
        if(!aviso){ aviso = document.createElement('span'); aviso.className = 'sr-only ww-tab-aviso'; a.appendChild(aviso); }
        aviso.textContent = texto;
      } else if(aviso){ aviso.remove(); }
    });
  }
  enlaces.forEach(a=>{
    if(CAL_URL){ a.href = CAL_URL; a.target = '_blank'; a.rel = 'noopener noreferrer'; }
    else       { a.href = respaldo; a.removeAttribute('target'); }
    a.addEventListener('click',()=>wwTrack('agendar',{via:CAL_URL?'calendario':'correo',origen:a.dataset.ev||''}),{passive:true});
  });
  renderAvisoTab();
  window.wwRenderAgendaAviso = renderAvisoTab;
})();

/* ── custom cursor ── */
const cursor=document.getElementById('cursor');
const FINE_POINTER=window.matchMedia('(hover:hover) and (pointer:fine)').matches
  && !window.matchMedia('(prefers-reduced-motion:reduce)').matches;
if(FINE_POINTER) document.documentElement.classList.add('cursor-custom');
let curX=0,curY=0,curRaf=false;
document.addEventListener('mousemove',e=>{
  curX=e.clientX;curY=e.clientY;
  if(!curRaf){
    curRaf=true;
    requestAnimationFrame(()=>{cursor.style.transform='translate3d('+curX+'px,'+curY+'px,0) translate(-50%,-50%)';curRaf=false;});
  }
},{passive:true});
document.querySelectorAll('a,button,[data-tilt]').forEach(el=>{
  el.addEventListener('mouseenter',()=>cursor.classList.add('big'));
  el.addEventListener('mouseleave',()=>cursor.classList.remove('big'));
});

/* ── barra de progreso ──
   Antes leía document.documentElement.scrollHeight dentro del rAF de cada frame.
   Esa lectura invalida el layout y, con content-visibility en las secciones, obliga
   al navegador a medir subárboles que se estaba saltando. Ahora se cachea. */
const bar=document.getElementById('scroll-progress');
let _scrollRange=1;
function measureScrollRange(){
  _scrollRange=Math.max(document.documentElement.scrollHeight-window.innerHeight,1);
}
measureScrollRange();
window.addEventListener('load',measureScrollRange);
window.addEventListener('resize',measureScrollRange,{passive:true});

/* ── reveal ── */
const revealObs=new IntersectionObserver(entries=>{entries.forEach(en=>{if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.15});
document.querySelectorAll('.reveal').forEach(el=>revealObs.observe(el));

/* ── counters ── */
document.querySelectorAll('.stat-num[data-target]').forEach(el=>{
  const obs=new IntersectionObserver(entries=>{
    entries.forEach(en=>{
      if(en.isIntersecting){
        const target=parseInt(el.dataset.target),prefix=el.dataset.prefix||'',suffix=el.dataset.suffix||'';
        const start=performance.now(),dur=1500;
        function step(t){const p=Math.min((t-start)/dur,1);el.textContent=prefix+Math.floor(p*target)+suffix;if(p<1)requestAnimationFrame(step);}
        requestAnimationFrame(step);obs.disconnect();
      }
    });
  },{threshold:.4});
  obs.observe(el);
});

/* ── text scramble ── */
const SCR_CHARS='!<>-_\\/[]{}—=+*^?#________';
function scramble(el,finalText,duration=700){
  const len=finalText.length;let frame=0;const totalFrames=Math.round(duration/30);
  const reveal=Math.ceil(len/totalFrames);
  function tick(){
    let out='';
    const revealed=Math.min(len,Math.floor(frame*reveal));
    for(let i=0;i<len;i++){
      if(i<revealed) out+=finalText[i];
      else if(finalText[i]===' ') out+=' ';
      else out+=SCR_CHARS[Math.floor(Math.random()*SCR_CHARS.length)];
    }
    el.textContent=out;
    frame++;
    if(revealed<len) requestAnimationFrame(tick);
    else el.textContent=finalText;
  }
  tick();
}
const scrambleEls=Array.from(document.querySelectorAll('[data-scramble]'));
scrambleEls.forEach(el=>{
  const final=el.textContent;
  el.dataset.final=final;
  el.addEventListener('mouseenter',()=>scramble(el,final,500));
});
if(scrambleEls.length){
  let scrambleIdx=0,tickerVisible=false;
  const tickerStrip=document.querySelector('.ticker-strip');
  if(tickerStrip){
    new IntersectionObserver(entries=>{
      tickerVisible=entries[0].isIntersecting;
    },{threshold:0}).observe(tickerStrip);
  }
  setInterval(()=>{
    if(window._wwHidden||window._wwMotionPaused||!tickerVisible)return;
    const el=scrambleEls[scrambleIdx%scrambleEls.length];
    scramble(el,el.dataset.final,500);
    scrambleIdx++;
  },1800);
}

/* ── ticker marquee: pixel-precise loop, no seam gap (paused off-screen) ── */
(function(){
  const track=document.getElementById('ticker');
  if(!track)return;
  let pos=0,setWidth=0,running=false,animId=null;
  function measure(){
    setWidth=track.scrollWidth/2;
  }
  measure();
  window.addEventListener('resize',measure);
  function loop(){
    if(!running)return;
    if(!window._wwHidden&&!window._wwMotionPaused){
      pos+=0.6;
      if(setWidth>0 && pos>=setWidth) pos-=setWidth;
      track.style.transform='translate3d(-'+pos+'px,0,0)';
    }
    animId=requestAnimationFrame(loop);
  }
  new IntersectionObserver(entries=>{
    entries.forEach(en=>{
      if(en.isIntersecting && !running){running=true;loop();}
      else if(!en.isIntersecting && running){running=false;if(animId)cancelAnimationFrame(animId);}
    });
  },{threshold:0}).observe(track);
})();
/* ── typewriter differentiators ── */
function typeText(el,text,accentWord,speed=38){
  const titleEl=el.querySelector('.typed-text');
  const cursorEl=el.querySelector('.cursor-blink');
  titleEl.textContent='';
  cursorEl.style.display='inline-block';
  let i=0;
  function type(){
    if(i<text.length){ titleEl.textContent+=text[i]; i++; setTimeout(type,speed); }
    else{
      if(accentWord){
        const parts=text.split(accentWord);
        if(parts.length>1) titleEl.innerHTML=parts[0]+'<span class="typed-accent">'+accentWord+'</span>'+parts.slice(1).join(accentWord);
      }
      setTimeout(()=>{cursorEl.style.display='none';},1200);
    }
  }
  type();
}
const diffObs=new IntersectionObserver(entries=>{
  entries.forEach(en=>{
    if(en.isIntersecting){
      const item=en.target;
      item.classList.add('visible');
      /* El acento se elegía siempre desde data-accent, que está en español. Al repintar
         un diferenciador ya escrito sí se miraba data-accent-en, pero el caso normal en
         inglés es el contrario: la página ya está en EN y el elemento se escribe por
         primera vez al entrar en viewport. Ahí la palabra española no aparecía en el
         texto inglés y el resaltado desaparecía, en los seis, sin error ninguno. */
      const acc = document.documentElement.lang === 'en'
        ? (item.dataset.accentEn || item.dataset.accent || '')
        : (item.dataset.accent || '');
      setTimeout(()=>typeText(item,item.dataset.typed||'',acc),200);
      diffObs.unobserve(item);
    }
  });
},{threshold:.3});
document.querySelectorAll('.diff-item').forEach(d=>diffObs.observe(d));

/* ── particles canvas (used across all sections except hero) ── */
/* Cada sección tenía su propio lienzo de partículas a resolución completa: hasta
   tres visibles a la vez repintando ~1400x900 píxeles por frame para dibujar 28
   puntos. El lienzo pasa a media resolución y se escala por CSS —a este tamaño de
   partícula es indistinguible— y se respeta el interruptor global de movimiento. */
document.querySelectorAll('.particles-canvas').forEach(canvas=>{
  const ctx=canvas.getContext('2d',{alpha:true});
  const SCALE=0.5;
  let particles=[];
  let running=false,animId=null;
  function resize(){
    const w=canvas.parentElement.offsetWidth, h=canvas.parentElement.offsetHeight;
    canvas.width=Math.max(Math.round(w*SCALE),1);
    canvas.height=Math.max(Math.round(h*SCALE),1);
    canvas.style.width=w+'px'; canvas.style.height=h+'px';
  }
  resize();
  let rzT; window.addEventListener('resize',()=>{clearTimeout(rzT);rzT=setTimeout(resize,200);},{passive:true});
  function Particle(){
    this.x=Math.random()*canvas.width; this.y=Math.random()*canvas.height;
    /* medidas en píxeles de lienzo: al escalarse x2 por CSS se ven igual que antes */
    this.size=Math.random()*1+0.5; this.speedX=(Math.random()-0.5)*0.2; this.speedY=-(Math.random()*0.25+0.1);
    this.opacity=Math.random()*0.5+0.1; this.life=0; this.maxLife=Math.random()*200+100;
  }
  const PARTICLE_COUNT=window.innerWidth<760?8:16;
  for(let i=0;i<PARTICLE_COUNT;i++) particles.push(new Particle());
  function animate(){
    if(!running)return;
    if(window._wwHidden||window._wwMotionPaused){animId=requestAnimationFrame(animate);return;}
    ctx.clearRect(0,0,canvas.width,canvas.height);
    particles.forEach((p,idx)=>{
      p.x+=p.speedX;p.y+=p.speedY;p.life++;
      const fade=p.life<20?p.life/20:p.life>p.maxLife-20?(p.maxLife-p.life)/20:1;
      ctx.beginPath();ctx.arc(p.x,p.y,p.size,0,Math.PI*2);
      ctx.fillStyle=`rgba(45,91,255,${p.opacity*fade})`;ctx.fill();
      if(p.life>=p.maxLife||p.y<0) particles[idx]=new Particle();
    });
    animId=requestAnimationFrame(animate);
  }
  const pObs=new IntersectionObserver(entries=>{
    entries.forEach(en=>{
      if(en.isIntersecting && !running){ running=true; animate(); }
      else if(!en.isIntersecting && running){ running=false; if(animId)cancelAnimationFrame(animId); }
    });
  },{threshold:0});
  pObs.observe(canvas);
});

/* El titular animado del hero (GooeyText) se ha retirado: el elemento de mayor
   peso visual de la página estaba en movimiento perpetuo y no llegaba a leerse en los
   3 s de una primera impresión. El H1 es ahora texto fijo en el HTML. Con él se van
   window.GOO_WORDS, el filtro SVG #threshold y las claves goo-words del diccionario. */
/* ── faq accordion ──
   Los 9 botones llevan aria-expanded y aria-controls en el HTML (apuntando al id de
   su .faq-answer), pero antes nada los mantenía al día: un lector de pantalla los
   oía siempre como "contraído", abierta o no. Aquí se conmuta el atributo en el
   mismo punto donde ya se conmuta la clase .open, para las dos preguntas que cambian
   en cada clic — la que se abre y la que se cierra. */
document.querySelectorAll('.faq-item').forEach(item=>{
  const btn=item.querySelector('.faq-question'),ans=item.querySelector('.faq-answer');
  btn.addEventListener('click',()=>{
    const isOpen=item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(o=>{
      o.classList.remove('open');
      o.querySelector('.faq-answer').style.maxHeight=null;
      o.querySelector('.faq-question').setAttribute('aria-expanded','false');
    });
    if(!isOpen){
      item.classList.add('open');ans.style.maxHeight=ans.scrollHeight+'px';
      btn.setAttribute('aria-expanded','true');
      /* qué objeción pesa más: la pregunta que más se abre debería subir de sitio */
      wwTrack('faq',{pregunta:item.dataset.faq||'?'});
    }
  });
});

/* ── form modal ── */
const modal=document.getElementById('form-modal');
const modalBox=document.getElementById('form-modal-box');
const formStep=document.getElementById('form-step');
const thankyouStep=document.getElementById('thankyou-step');

function closeModal(){
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden','true');
  document.body.style.overflow='';
  if(modalLastFocus){modalLastFocus.focus();modalLastFocus=null;}
}
function resetModal(){
  modalBox.classList.remove('ty-active');
  thankyouStep.hidden=true;
  formStep.hidden=false;
  if(window._wwResetFormState) window._wwResetFormState();
}
function showThankYou(){
  formStep.hidden=true;
  thankyouStep.hidden=false;
  modalBox.classList.add('ty-active');
  modalBox.scrollTop=0;
}

/* Un único listener delegado para los CTAs: cada uno declara su nombre de evento
   en data-ev, así añadir o mover un botón no obliga a tocar la analítica. */
document.addEventListener('click',e=>{
  const el=e.target.closest('[data-ev]');
  if(el) wwTrack('cta',{cta:el.dataset.ev});
},{passive:true});

/* ── caras del formulario ────────────────────────────────────────────────────
   El modal era uno solo para los ocho CTA: quien pulsaba "Probar por 490 €" recibía
   un formulario titulado "Prueba gratis · Tres fotos gratis · sin tarjeta · las fotos
   son tuyas contrates o no". Es decir, el sitio le decía que no hacía falta pagar
   justo en el momento en que acababa de decidir pagar — y ese es el lead más caro de
   la página.
   Una "cara" son claves de traducción con sufijo: si la cara es 'pack', se usa
   form-title-pack donde antes iba form-title. Lo que una cara no redefine se queda
   con el texto por defecto, así que una cara nueva solo escribe lo que de verdad
   cambia. Añadir otra = una entrada aquí y sus claves en TRANSLATIONS.
   El plazo y el precio NO se tocan desde aquí: viven en el diccionario, para que la
   versión inglesa los reciba igual que el resto del copy.
   ───────────────────────────────────────────────────────────────────────────── */
const CARAS_CTA = { 'price-arranque-cta': 'pack' };
/* [id del elemento, clave base, ¿innerHTML?] */
const CAMPOS_CARA = [
  ['wwform-eyebrow','form-eyebrow',false],
  ['wwform-title','form-title',true],
  ['wwform-sub','form-sub',false],
  ['ww-email-help','form-email-help',false],
  ['wwform-quota','form-quota',true],
  ['wwform-fine','form-fine',false],
  ['ww-submit','form-submit',false],
  ['ww-product-label','form-product-label',true],
  ['ww-assets-nota','form-assets-nota',false],
  ['ty-assets-head','ty-assets-head',false],
  ['ty-assets-body','ty-assets-body',false],
  ['ty-assets-fine','ty-assets-fine',false]
];

/* ── DÓNDE MANDAR LOS ASSETS ─────────────────────────────────────────────────
   Un único sitio que decide qué se le dice al cliente al terminar. Hoy es el correo
   porque es lo que existe; el día que haya una carpeta de Drive o un servicio de
   subida, se cambia esta constante y no hay que tocar ni el HTML ni las dos
   traducciones. `tipo` solo elige cómo se construye el enlace.
   PENDIENTE DE DECISIÓN DEL PROPIETARIO: correo contra carpeta de Drive. Con Drive
   hay que dejarla abierta a "cualquiera con el enlace puede subir", o el cliente se
   encuentra un permiso denegado justo después de reservar.
   ───────────────────────────────────────────────────────────────────────────── */
const DESTINO_ASSETS = {
  tipo: 'email',                                   // 'email' | 'enlace'
  valor: 'worldisaiagency@gmail.com',
  asunto: 'Referencias y fotos de producto — WORLDWORK'
};

/* Requisitos por cara. En la prueba gratis se piden DOS datos porque la sección
   promete "nos das tu Instagram, nada más"; en el pack se piden los que hacen falta
   para facturar y empezar, y por eso van repartidos en tres pasos. */
const REQUERIDOS = {
  prueba: ['ww-brand','ww-email'],
  /* El teléfono NO es obligatorio: es el campo que más abandono provoca en B2B y
     la propia ayuda del campo dice que no hacemos llamadas comerciales — exigirlo
     sería cobrar un peaje por algo que no vamos a usar. Quien tiene un proyecto en
     marcha lo deja igual. */
  pack:   ['ww-brand','ww-product','ww-email','ww-name','ww-country']
};
/* Caras que van por pasos. La prueba no está aquí: se muestra entera de una vez. */
const CARAS_POR_PASOS = { pack: 3 };

let caraFormulario='';
let pasoActual=1;
function textoCara(t,clave){
  if(!t) return '';
  return (caraFormulario && t[clave+'-'+caraFormulario]) || t[clave] || '';
}
const caraActiva = () => caraFormulario || 'prueba';
const totalPasos = () => CARAS_POR_PASOS[caraActiva()] || 1;
const esObligatorio = (id) => (REQUERIDOS[caraActiva()] || []).includes(id);

/* Muestra los campos de la cara activa y, si la cara va por pasos, solo los del paso.
   Un campo oculto no se valida ni se envía vacío por error: la validación recorre
   REQUERIDOS, que ya es por cara. */
function pintarPasos(){
  const cara = caraActiva();
  const porPasos = totalPasos() > 1;
  document.querySelectorAll('#wwform [data-caras]').forEach(el=>{
    const suyo = el.dataset.caras.split(' ').includes(cara);
    const enPaso = !porPasos || String(pasoActual) === el.dataset.paso;
    el.hidden = !(suyo && enPaso);
  });
  const nav = document.getElementById('ww-nav');
  const submit = document.getElementById('ww-submit');
  const barra = document.getElementById('ww-steps');
  const ultimo = pasoActual >= totalPasos();
  if(barra) barra.hidden = !porPasos;
  if(nav) nav.hidden = !porPasos;
  /* En el último paso manda el botón de enviar y "Siguiente" desaparece: dos botones
     que parecen hacer lo mismo al final es la forma más rápida de que alguien pulse
     el que no envía y crea que ya ha terminado. */
  if(submit) submit.hidden = porPasos && !ultimo;
  const next = document.getElementById('ww-next');
  const prev = document.getElementById('ww-prev');
  if(next) next.hidden = ultimo;
  if(prev) prev.hidden = pasoActual === 1;
  document.querySelectorAll('.wwsteps-list li').forEach(li=>{
    const n = Number(li.dataset.p);
    li.classList.toggle('activo', n === pasoActual);
    li.classList.toggle('hecho', n < pasoActual);
    if(n === pasoActual) li.setAttribute('aria-current','step'); else li.removeAttribute('aria-current');
  });
  /* La cuota y la letra pequeña solo tienen sentido junto al botón de enviar. */
  const quota = document.getElementById('wwform-quota');
  const fine  = document.getElementById('wwform-fine');
  if(quota) quota.hidden = porPasos && !ultimo;
  if(fine)  fine.hidden  = porPasos && !ultimo;
}

function irAPaso(n, mover){
  pasoActual = Math.min(Math.max(1, n), totalPasos());
  pintarPasos();
  const caja = document.getElementById('form-modal-box');
  if(caja) caja.scrollTop = 0;
  /* El foco viaja al primer campo del paso nuevo: sin esto, quien navega con teclado
     se queda con el foco en un botón que acaba de desaparecer. */
  if(mover){
    const primero = document.querySelector('#wwform [data-caras]:not([hidden]) input, #wwform [data-caras]:not([hidden]) textarea');
    if(primero) primero.focus();
  }
}

function aplicarCaraFormulario(){
  let t={};
  try{ t=TRANSLATIONS[document.documentElement.lang==='en'?'en':'es']||{}; }catch(_){ }
  CAMPOS_CARA.forEach(([id,clave,html])=>{
    const el=document.getElementById(id);
    const txt=textoCara(t,clave);
    if(el&&txt) el[html?'innerHTML':'textContent']=txt;
  });
  /* Los placeholders también cambian de cara: el del producto pide un nombre en la
     prueba y una URL en el pack, y un placeholder que no concuerda con su etiqueta
     es peor que no tenerlo. Va aparte de CAMPOS_CARA porque se escribe en una
     propiedad, no en el contenido del elemento. */
  [['ww-product','form-product-ph']].forEach(([id,clave])=>{
    const el=document.getElementById(id);
    const v=textoCara(t,clave);
    if(el&&v) el.placeholder=v;
  });
  /* Marcar como opcional lo que en esta cara no lo es. El "opcional" del nombre está
     escrito en el HTML porque en la prueba lo es; en el pack hace falta para la
     factura, así que se retira. */
  const optNombre = document.querySelector('#ww-name-label .wwopt');
  if(optNombre) optNombre.hidden = esObligatorio('ww-name');

  /* El destino de los assets, en la pantalla de gracias. */
  const enlace = document.getElementById('ty-assets-link');
  if(enlace && DESTINO_ASSETS.valor){
    if(DESTINO_ASSETS.tipo === 'email'){
      enlace.href = 'mailto:' + DESTINO_ASSETS.valor + '?subject=' + encodeURIComponent(DESTINO_ASSETS.asunto);
      enlace.textContent = DESTINO_ASSETS.valor;
      enlace.removeAttribute('target'); enlace.removeAttribute('rel');
    }else{
      enlace.href = DESTINO_ASSETS.valor;
      enlace.textContent = t['ty-assets-cta'] || 'Subir mis archivos →';
      enlace.target = '_blank'; enlace.rel = 'noopener noreferrer';
    }
  }

  /* La pantalla de gracias también cambia. Sin esto, quien reserva el pack de 490 €
     acaba leyendo "recibes tus tres fotos gratis en 72 h": el mismo desajuste que se
     acaba de corregir, un paso más adelante. */
  const pasos=document.querySelectorAll('.ty-step');
  [0,1,2].forEach(i=>{
    if(!pasos[i]) return;
    const h=textoCara(t,'ty-step'+(i+1)+'-h'), p=textoCara(t,'ty-step'+(i+1)+'-p');
    if(h) pasos[i].querySelector('h4').textContent=h;
    if(p) pasos[i].querySelector('p').textContent=p;
  });
  pintarPasos();
}

let modalLastFocus=null;
let origenApertura='directo';
/* Extraído a función para poder abrir el modal también sin que haya habido un
   clic real — ver más abajo, ?abrir=prueba desde el portfolio. `el` puede ser
   null: en ese caso no hay foco al que volver al cerrar, y closeModal() ya
   contempla ese caso (solo devuelve el foco si modalLastFocus existe). */
function abrirModal(el, origen){
  modalLastFocus=el;
  origenApertura=origen||'directo';
  window._wwOrigenFormulario=origenApertura;
  caraFormulario=CARAS_CTA[origenApertura]||'';
  pasoActual=1;
  wwTrack('formulario-abierto',{origen:origenApertura,cara:caraFormulario||'prueba'});
  resetModal();
  /* después de resetModal: él restaura el texto del botón de enviar, así que pintar
     la cara antes lo dejaría con el texto por defecto. */
  aplicarCaraFormulario();
  modal.classList.add('open');
  modal.setAttribute('aria-hidden','false');
  document.body.style.overflow='hidden';
  document.getElementById('form-modal-close').focus();
}
document.querySelectorAll('[data-form-open]').forEach(b=>b.addEventListener('click',e=>{
  e.preventDefault();
  abrirModal(e.currentTarget, e.currentTarget.dataset.ev);
}));

/* ── llegada desde el portfolio con ?abrir=prueba ──────────────────────────────
   El portfolio es una página estática sin el modal ni este script: su enlace "¿lo
   pruebas gratis primero?" solo puede volver a la home y pedirle que abra el
   formulario ella misma. history.replaceState quita el parámetro de la URL nada
   más abrirlo, para que recargar la página o compartir el enlace no reabra el
   modal cada vez. */
(function(){
  const params=new URLSearchParams(location.search);
  if(params.get('abrir')!=='prueba') return;
  abrirModal(null,'portfolio-prueba');
  params.delete('abrir');
  const resto=params.toString();
  history.replaceState(null,'',location.pathname+(resto?'?'+resto:'')+location.hash);
})();
/* focus trap: sin esto el tabulador se escapaba detrás del modal y el usuario de
   teclado quedaba navegando una página que visualmente no puede ver. */
modal.addEventListener('keydown',e=>{
  if(e.key==='Escape'){closeModal();return;}
  if(e.key!=='Tab')return;
  /* input/select/textarea entraron en la lista al pasar el formulario a nativo: sin
     ellos la trampa de foco saltaba por encima de los propios campos del formulario. */
  const f=modal.querySelectorAll('a[href],button:not([disabled]),input:not([tabindex="-1"]),select,textarea,[tabindex]:not([tabindex="-1"])');
  if(!f.length)return;
  const first=f[0],last=f[f.length-1];
  if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
  else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
});
document.getElementById('form-modal-close').addEventListener('click',closeModal);
document.getElementById('ty-home').addEventListener('click',closeModal);
document.getElementById('ty-work-link').addEventListener('click',closeModal);

/* ── envío del formulario y navegación por pasos ─────────────────────────────
   FORM_ENDPOINT vacío = modo correo: el formulario compone un mensaje con los datos
   ya escritos y abre el cliente de email. Así funciona desde el primer día sin dar
   de alta ningún servicio. Al pegar aquí la URL de Formspree, Resend o un Worker,
   pasa a enviar por POST y el visitante no sale del sitio en ningún momento.

   Los ADJUNTOS se han retirado. Iban en multipart, dependían del plan del proveedor
   y arrastraban un reintento sin ficheros más un aviso en la pantalla de gracias
   para cuando el proveedor los rechazaba. Todo eso existía para resolver algo que se
   resuelve mejor pidiendo los archivos por correo cuando ya hay conversación: el
   envío vuelve a ser un JSON y el destino de los archivos vive en DESTINO_ASSETS.
   ───────────────────────────────────────────────────────────────────────────── */
(function(){
  const FORM_ENDPOINT = 'https://formspree.io/f/xaqrrwwp';
  const FALLBACK_EMAIL = 'worldisaiagency@gmail.com';

  const form   = document.getElementById('wwform');
  const submit = document.getElementById('ww-submit');
  const formErr= document.getElementById('ww-form-err');
  if(!form) return;

  /* Un campo se describe una vez; qué es obligatorio lo decide la cara activa
     (REQUERIDOS), no esta lista. Así el mismo campo puede ser opcional en la prueba
     gratis y obligatorio en el pack sin duplicar nada. */
  const CAMPOS = [
    { id:'ww-brand',   err:'ww-brand-err',   clave:'err-brand' },
    { id:'ww-product', err:'ww-product-err', clave:'err-product' },
    { id:'ww-email',   err:'ww-email-err',   clave:'err-email', email:true },
    { id:'ww-phone',   err:'ww-phone-err',   clave:'err-phone', tel:true },
    { id:'ww-name',    err:'ww-name-err',    clave:'err-name' },
    { id:'ww-country', err:'ww-country-err', clave:'err-country' }
  ];

  /* TRANSLATIONS se declara más abajo en el mismo script: para cuando alguien pulsa
     enviar, hace rato que se ha evaluado. El try cubre el caso de que no exista. */
  const T = () => { try{ return TRANSLATIONS[document.documentElement.lang==='en'?'en':'es'] || {}; }catch(_){ return {}; } };

  function pintarError(c, mostrar){
    const input = document.getElementById(c.id);
    const p     = document.getElementById(c.err);
    if(!input||!p) return;
    if(mostrar){
      p.textContent = T()[c.clave] || 'Revisa este campo.';
      p.hidden = false;
      input.setAttribute('aria-invalid','true');
    }else{
      p.hidden = true;
      input.removeAttribute('aria-invalid');
    }
  }
  /* validación deliberadamente laxa: rechazar una entrada válida cuesta un lead,
     y aquí el coste de dejar pasar una dudosa es cero — la revisa una persona.
     El teléfono solo comprueba que haya suficientes dígitos: los formatos reales
     (+34, espacios, guiones, paréntesis) son incontables y ninguno es un error. */
  const emailOk = v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());
  const telOk   = v => (v.replace(/\D/g,'').length >= 7);

  function valorDe(c){ const el=document.getElementById(c.id); return el ? (el.value||'').trim() : ''; }
  function validar(c){
    const v = valorDe(c);
    const req = (typeof esObligatorio==='function') && esObligatorio(c.id);
    if(req && !v) return false;
    if(c.email && v && !emailOk(v)) return false;
    if(c.tel   && v && !telOk(v))   return false;
    return true;
  }
  /* Solo los campos que se ven ahora mismo: en la cara por pasos, avisar de un error
     en un campo de otro paso deja al visitante buscando algo que no está en pantalla. */
  const camposVisibles = () => CAMPOS.filter(c=>{
    const el = document.getElementById(c.id);
    const cont = el && el.closest('[data-caras]');
    return cont && !cont.hidden;
  });

  CAMPOS.forEach(c=>{
    const input=document.getElementById(c.id);
    if(!input) return;
    input.addEventListener('blur', ()=>{ if(input.value.trim()) pintarError(c, !validar(c)); });
    input.addEventListener('input',()=>{ if(input.getAttribute('aria-invalid')==='true' && validar(c)) pintarError(c,false); });
  });

  /* Valida lo que hay en pantalla y devuelve el primer campo que falla, o null. */
  function revisarVisibles(){
    let primerFallo = null;
    camposVisibles().forEach(c=>{
      const ok = validar(c);
      pintarError(c,!ok);
      if(!ok && !primerFallo) primerFallo = c;
    });
    return primerFallo;
  }

  window._wwResetFormState = function(){
    CAMPOS.forEach(c=>pintarError(c,false));
    if(formErr) formErr.hidden = true;
    if(submit){
      submit.removeAttribute('aria-busy');
      submit.removeAttribute('aria-disabled');
      submit.textContent = textoCara(T(),'form-submit') || 'Pedir mis tres fotos';
    }
  };

  /* ── navegación por pasos ── */
  const btnNext = document.getElementById('ww-next');
  const btnPrev = document.getElementById('ww-prev');
  if(btnNext) btnNext.addEventListener('click', ()=>{
    const fallo = revisarVisibles();
    if(fallo){
      wwTrack('formulario-validacion',{campo:fallo.id.replace('ww-',''),paso:pasoActual});
      document.getElementById(fallo.id).focus();
      return;
    }
    wwTrack('formulario-paso',{paso:pasoActual});
    irAPaso(pasoActual+1, true);
  });
  if(btnPrev) btnPrev.addEventListener('click', ()=>irAPaso(pasoActual-1, true));
  /* Enter en un campo intermedio avanza de paso en vez de enviar el formulario a
     medias: sin esto, el navegador dispara submit desde el paso 1. */
  form.addEventListener('keydown', e=>{
    if(e.key!=='Enter') return;
    if(e.target.tagName==='TEXTAREA') return;
    if(typeof totalPasos==='function' && pasoActual < totalPasos()){
      e.preventDefault();
      if(btnNext) btnNext.click();
    }
  });

  let enviando = false;
  form.addEventListener('submit', async e=>{
    e.preventDefault();
    if(enviando) return;
    if(formErr) formErr.hidden = true;

    /* trampa de bots: si viene rellena, fingimos éxito y no enviamos nada */
    if((form.querySelector('[name="_gotcha"]')||{}).value){ showThankYou(); return; }

    const primerFallo = revisarVisibles();
    if(primerFallo){
      /* qué campo frena a la gente: si esto se dispara mucho, el campo está mal
         explicado o mal pedido, no es que el visitante se equivoque */
      wwTrack('formulario-validacion',{campo:primerFallo.id.replace('ww-','')});
      document.getElementById(primerFallo.id).focus();
      return;
    }

    /* La procedencia va en campos sueltos y legibles, no enterrada en la URL: en el
       correo se lee "utm_campaign: joyeria-julio" en vez de tener que descifrar una
       query. Se añade el CTA que abrió el modal, que ya teníamos.
       `solicitud` en claro y arriba del todo: el correo llevaba solo
       cta:"price-arranque-cta", y confundir una reserva de 490 € con una prueba
       gratis —contestarle a un cliente que paga como si pidiera algo regalado— es un
       error de 490 € que no puede depender de recordar qué significa cada slug. */
    const lee = id => { const el=document.getElementById(id); return el ? el.value.trim() : ''; };
    const datos = Object.assign({
      solicitud: caraFormulario === 'pack' ? 'RESERVA PACK 490 €' : 'Prueba gratis (3 fotos)',
      marca:     lee('ww-brand'),
      email:     lee('ww-email'),
      telefono:  lee('ww-phone'),
      nombre:    lee('ww-name'),
      producto:  lee('ww-product'),
      brief:     lee('ww-brief'),
      pais:      lee('ww-country'),
      idioma:    document.documentElement.lang,
      cta:       window._wwOrigenFormulario || 'directo',
      origen:    location.href
    }, WW_FUENTE);

    if(!FORM_ENDPOINT){
      /* Modo correo, mientras no haya endpoint. Aquí NO se enseña la pantalla de
         gracias: dice "hemos recibido tu solicitud" y en este modo no hemos recibido
         nada — si el visitante no tiene cliente de correo configurado, el mailto no
         abre nada y le estaríamos dando las gracias por un envío que no existe.
         Se le dice la verdad y se le deja el enlace a mano. */
      const cuerpo = [
        'Solicitud: ' + datos.solicitud,
        'Marca: '     + datos.marca,
        'Email: '     + datos.email,
        'Teléfono: '  + (datos.telefono || '—'),
        'Nombre: '    + (datos.nombre   || '—'),
        'Producto: '  + (datos.producto || '—'),
        'Idea: '      + (datos.brief    || '—')
      ].join('\n');
      const href = 'mailto:' + FALLBACK_EMAIL
        + '?subject=' + encodeURIComponent(datos.solicitud + ' — ' + datos.marca)
        + '&body='    + encodeURIComponent(cuerpo);
      window.location.href = href;
      if(formErr){
        formErr.innerHTML = (T()['form-mailto'] || 'Te hemos abierto el correo con todo escrito: solo tienes que darle a enviar.')
          + ' <a href="'+href+'">' + (T()['form-mailto-link'] || 'Abrirlo de nuevo') + '</a>';
        formErr.hidden = false;
      }
      return;
    }

    /* aria-disabled además de aria-busy: el CSS lo despinta con pointer-events,
       pero eso no frena al teclado ni se lo cuenta a un lector de pantalla. El
       flag `enviando` es el que impide de verdad el doble envío. */
    enviando = true;
    submit.setAttribute('aria-busy','true');
    submit.setAttribute('aria-disabled','true');
    submit.textContent = T()['form-sending'] || 'Enviando…';
    try{
      const r = await fetch(FORM_ENDPOINT, {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify(datos)
      });
      if(!r.ok) throw new Error(r.status);
      form.reset();
      /* la métrica que importa: enviados / abiertos, y desde qué CTA venía */
      wwTrack('formulario-enviado',{origen:window._wwOrigenFormulario||'directo',cara:caraActiva()});
      showThankYou();
    }catch(_){
      wwTrack('formulario-fallo',{});
      /* nunca dejar al visitante sin salida: se le da el correo con todo escrito */
      if(formErr){
        const cuerpo = 'Marca: '+datos.marca+'\nEmail: '+datos.email;
        formErr.innerHTML = (T()['form-error'] || 'No hemos podido enviarlo. Escríbenos y te respondemos igual de rápido:')
          + ' <a href="mailto:'+FALLBACK_EMAIL+'?subject='+encodeURIComponent(datos.solicitud+' — '+datos.marca)
          + '&body='+encodeURIComponent(cuerpo)+'">'+FALLBACK_EMAIL+'</a>';
        formErr.hidden = false;
      }
    }finally{
      enviando = false;
      submit.removeAttribute('aria-busy');
      submit.removeAttribute('aria-disabled');
      /* por cara, no por la clave base: tras un envío o un fallo, el botón del pack
         volvía a decir "Pedir mis tres fotos". */
      submit.textContent = textoCara(T(),'form-submit') || 'Pedir mis tres fotos';
    }
  });
})();

/* ── video carousel: auto-scroll → pause on hover → lightbox on click ── */
(function(){
  const outer=document.getElementById('vcarousel-outer');
  const track=document.getElementById('vcarousel-track');
  const lightbox=document.getElementById('vid-lightbox');
  const lbBg=document.getElementById('vid-lightbox-bg');
  const lbWrap=document.getElementById('vid-lightbox-wrap');
  const lbClose=document.getElementById('vid-lightbox-close');
  if(!track||!outer)return;
  let pos=0,paused=false,lbOpen=false;
  const SPEED_REF=1.4,REF_WIDTH=1920;
  function safePlay(v){
    v._wantPlay=true;
    if(v._playPromise){ v._playPromise.then(()=>{ if(v._wantPlay) v.play().catch(()=>{}); }).catch(()=>{}); return; }
    v._playPromise=v.play().catch(()=>{}).finally(()=>{ v._playPromise=null; });
  }
  function safePause(v){
    v._wantPlay=false;
    if(v._playPromise){ v._playPromise.then(()=>{ if(!v._wantPlay) v.pause(); }).catch(()=>{}); return; }
    v.pause();
  }
  track.querySelectorAll('video').forEach(v=>{
    v.addEventListener('error',()=>{
      const src=v.currentSrc||v.src;
      if(!src)return;
      v.load();
      if(v._wantPlay) safePlay(v);
    });
  });
  /* Móvil puede rechazar un play() que no cuelgue de un gesto real: Chrome con
     AbortError ("video-only background media was paused to save power"), iOS Safari
     de forma más estricta todavía. El vídeo que entra en el viewport vía
     IntersectionObserver casi nunca lo hace en el mismo instante que un toque, así
     que ese primer intento falla en silencio (safePlay ya atrapaba el error, pero
     nunca reintentaba) y se queda clavado en su primer frame para siempre.
     Antes esto se reintentaba solo una vez ({once:true}) en el primer toque de toda
     la página — que normalmente ocurre arriba, en el hero, mucho antes de llegar a
     los vídeos, así que para cuando el vídeo fallaba de verdad ya no quedaba ningún
     reintento. Ahora se reintenta en cada toque, no solo el primero: cualquier vídeo
     que quiera reproducirse y siga pausado se reintenta dentro del propio manejador
     del evento (sin await de por medio), para que el play() cuelgue del gesto. */
  function retryStuckVideos(){
    track.querySelectorAll('video').forEach(v=>{ if(v._wantPlay&&v.paused) safePlay(v); });
  }
  ['pointerdown','touchstart','scroll'].forEach(ev=>window.addEventListener(ev,retryStuckVideos,{passive:true}));
  /* Los 5 pósters (data-poster, antes poster= a secas) se cargaban con la página
     entera: preload="none" frena el VÍDEO, pero un atributo poster nativo lo
     descarga el navegador en cuanto lee el HTML, sin esperar a que la sección esté
     cerca del viewport — 116 KB compitiendo con el recurso del LCP en cada carga,
     estuviera el carrusel a la vista o no.
     Este observer es solo para la imagen y va SEPARADO del que arranca el vídeo
     (vidObs, más abajo): rootMargin más generoso porque conviene que el póster ya
     esté puesto cuando la tarjeta empieza a entrar, no exactamente en ese instante.
     Las 5 tarjetas duplicadas (.vc-dup, el bucle infinito) comparten URL con las
     reales, así que el navegador solo descarga cada póster una vez aunque las 10
     etiquetas <video> lo pidan. */
  const posterObs=new IntersectionObserver(entries=>{
    entries.forEach(en=>{
      const v=en.target;
      if(en.isIntersecting){ v.poster=v.dataset.poster; posterObs.unobserve(v); }
    });
  },{rootMargin:'300px'});
  track.querySelectorAll('video[data-poster]').forEach(v=>posterObs.observe(v));

  /* rootMargin:200px (antes) trataba como "visible" cualquier tarjeta a menos de 200px
     del viewport a cada lado — con tarjetas de ~270px de ancho, eso ponía a reproducir
     6-9 de las 10 a la vez (5 reales + 5 duplicadas para el bucle), la mayoría fuera
     de pantalla. 0px reproduce solo lo que realmente se ve. */
  const vidObs=new IntersectionObserver(entries=>{
    entries.forEach(en=>{
      const v=en.target;
      if(en.isIntersecting) safePlay(v);
      else safePause(v);
    });
  },{rootMargin:'0px'});
  track.querySelectorAll('video').forEach(v=>vidObs.observe(v));
  /* el aspect-ratio real de cada clip va declarado inline en el HTML — no se calcula
     en runtime, que era lo que provocaba el salto de layout (CLS) al cargar los metadatos. */
  track.querySelectorAll('.vid-card').forEach(card=>{
    card.addEventListener('mouseenter',()=>{paused=true;});
    card.addEventListener('mouseleave',()=>{if(!lbOpen)paused=false;});
  });
  /* half y speed se medían dentro del bucle: track.scrollWidth es una lectura que
     fuerza layout en cada frame, con el carrusel a la vista y encima moviéndose.
     Se cachean y solo se recalculan al redimensionar o al cargar los vídeos. */
  let half=track.scrollWidth/2, speed=0, lastT=performance.now(), trackVisible=false, tickId=null;
  function measureTrack(){
    const next=track.scrollWidth/2;
    if(next>0&&half>0&&next!==half) pos=pos*(next/half);
    if(next>0) half=next;
    speed=window.innerWidth<=860?55:SPEED_REF*(window.innerWidth/REF_WIDTH)*60;
  }
  measureTrack();
  window.addEventListener('resize',measureTrack,{passive:true});
  track.querySelectorAll('video').forEach(v=>v.addEventListener('loadedmetadata',measureTrack,{once:true}));
  function tick(t){
    if(!trackVisible)return;
    const dt=Math.min(t-lastT,100);lastT=t;
    if(!paused&&!window._wwHidden&&!window._wwMotionPaused&&half>0){
      pos+=speed*(dt/1000);
      if(pos>=half)pos-=half;
      track.style.transform='translate3d(-'+pos+'px,0,0)';
    }
    tickId=requestAnimationFrame(tick);
  }
  new IntersectionObserver(entries=>{
    entries.forEach(en=>{
      if(en.isIntersecting && !trackVisible){trackVisible=true;lastT=performance.now();tick(lastT);}
      else if(!en.isIntersecting && trackVisible){trackVisible=false;if(tickId)cancelAnimationFrame(tickId);}
    });
  },{threshold:0}).observe(outer);
  let lbLastFocus=null;
  track.querySelectorAll('.vid-card:not(.vc-dup)').forEach(card=>{
    function openLb(){
      lbOpen=true;paused=true;
      lbLastFocus=card;
      lbWrap.innerHTML='';
      const clone=card.cloneNode(true);
      clone.removeAttribute('role');clone.removeAttribute('tabindex');clone.removeAttribute('aria-label');
      clone.style.height='auto';clone.style.maxHeight='90vh';clone.style.borderRadius='16px';
      clone.querySelectorAll('video').forEach(v=>{
        /* en el carrusel se sirve un preview ligero; al abrir el lightbox se carga
           el clip original a calidad completa, que es lo que el usuario ha pedido ver. */
        const full=v.dataset.full;
        if(full&&v.getAttribute('src')!==full){v.setAttribute('src',full);v.load();}
        v.controls=true;v.muted=false;v.play().catch(()=>{});
      });
      lbWrap.appendChild(clone);
      lightbox.classList.add('active');
      lightbox.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';
      lbClose.focus();
    }
    /* una sola puerta de entrada al lightbox: el clic directo y el de las tarjetas
       duplicadas pasan por aquí, así el evento se registra una vez en ambos casos */
    card._openLb=()=>{ wwTrack('video',{clip:card.dataset.idx}); openLb(); };
    /* sin handler de keydown: la tarjeta ya es un <button> nativo y Enter/Espacio
       emiten su propio click. Mantenerlo abría el lightbox dos veces. */
    card.addEventListener('click',e=>{e.preventDefault();card._openLb();});
  });
  track.querySelectorAll('.vid-card.vc-dup').forEach(dup=>{
    dup.addEventListener('click',e=>{
      e.preventDefault();
      const idx=dup.dataset.idx;
      const orig=track.querySelector('.vid-card:not(.vc-dup)[data-idx="'+idx+'"]');
      if(orig)orig.click();
    });
  });
  function closeLb(){
    if(!lbOpen)return;
    lbWrap.querySelectorAll('video').forEach(v=>v.pause());
    lightbox.classList.remove('active');
    lightbox.setAttribute('aria-hidden','true');
    lbWrap.innerHTML='';
    lbOpen=false;paused=false;
    document.body.style.overflow='';
    if(lbLastFocus){lbLastFocus.focus();lbLastFocus=null;}
  }
  lbBg.addEventListener('click',closeLb);
  lbClose.addEventListener('click',closeLb);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeLb();});
  /* trampa de foco: mismo patrón que el modal del formulario — sin esto el
     tabulador se escapaba detrás del lightbox con el vídeo todavía abierto. */
  lightbox.addEventListener('keydown',e=>{
    if(!lbOpen||e.key!=='Tab')return;
    const f=lightbox.querySelectorAll('a[href],button:not([disabled]),video[controls],[tabindex]:not([tabindex="-1"])');
    if(!f.length)return;
    const first=f[0],last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  });
})();

/* ── lightbox de foto para las galerías de #trabajo: mismo patrón que el de vídeo,
   más flechas propias — el visitante puede recorrer toda la pieza sin cerrar y
   volver a abrir. `nav` es la galería que abrió el lightbox: {get(dir)} devuelve
   {src,alt} de la pieza siguiente/anterior y mueve su propio índice a la vez, así
   que al cerrar y reabrir desde una miniatura, la galería de fondo ya está donde el
   lightbox la dejó. */
function openImgLightbox(src, alt, lastFocusEl, nav){
  const lb = document.getElementById('img-lightbox');
  const img = document.getElementById('img-lightbox-img');
  if(!lb || !img) return;
  img.src = src; img.alt = alt || '';
  lb.classList.add('active');
  lb.setAttribute('aria-hidden','false');
  lb._nav = nav || null;
  document.body.style.overflow = 'hidden';
  lb._lastFocus = lastFocusEl || null;
  document.getElementById('img-lightbox-close').focus();
}
(function(){
  const lb = document.getElementById('img-lightbox');
  if(!lb) return;
  const img = document.getElementById('img-lightbox-img');
  const prevBtn = document.getElementById('img-lightbox-prev');
  const nextBtn = document.getElementById('img-lightbox-next');
  function close(){
    if(!lb.classList.contains('active')) return;
    lb.classList.remove('active');
    lb.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    if(lb._lastFocus){ lb._lastFocus.focus(); lb._lastFocus = null; }
    lb._nav = null;
  }
  function go(dir){
    if(!lb._nav) return;
    const it = lb._nav.get(dir);
    if(!it) return;
    img.src = it.src; img.alt = it.alt || '';
  }
  document.getElementById('img-lightbox-bg').addEventListener('click', close);
  document.getElementById('img-lightbox-close').addEventListener('click', close);
  prevBtn.addEventListener('click', ()=>go(-1));
  nextBtn.addEventListener('click', ()=>go(1));
  document.addEventListener('keydown', e => {
    if(!lb.classList.contains('active')) return;
    if(e.key === 'Escape') close();
    else if(e.key === 'ArrowLeft') go(-1);
    else if(e.key === 'ArrowRight') go(1);
  });
  /* trampa de foco: mismo patrón que el modal del formulario y el lightbox de vídeo. */
  lb.addEventListener('keydown', e=>{
    if(!lb.classList.contains('active')||e.key!=='Tab')return;
    const f=lb.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])');
    if(!f.length)return;
    const first=f[0],last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  });
})();

/* ── GALERÍA (#galeria) ──
   Cómo añadir una foto: sube gallery-NN-t480.webp (miniatura, recorte 3:4) y
   gallery-NN-xl.webp (versión grande para el lightbox) a media/images/, siguiendo la
   numeración, y sube TOTAL_PHOTOS en uno. Nada de HTML ni de arrays que editar a
   mano — los nombres salen de esta fórmula.
   Cómo quitar una foto sin renumerar las demás: añade su número a EXCLUDED_PHOTOS
   y borra sus dos archivos de media/images/. */
const TOTAL_PHOTOS = 99;
const EXCLUDED_PHOTOS = [2, 25, 47, 59]; // gallery-02: efecto térmico no deseado; 25/47/59: descartadas a petición
const GALLERY_ITEMS = Array.from({length: TOTAL_PHOTOS}, (_, i) => i + 1)
  .filter(n => !EXCLUDED_PHOTOS.includes(n))
  .map(n => {
    const nn = String(n).padStart(2, '0');
    return {
      /* Rutas ABSOLUTAS desde la raíz, no relativas. Con 'media/...' a secas, este
         mismo script servía la home bien y dejaba la galería entera en blanco en
         /en/: una ruta relativa desde /en/index.html resuelve a /en/media/images/…,
         que no existe — 32 imágenes con 404 y una sección vacía. El HTML de la
         página inglesa ya usa '../media/', pero el JS es el mismo fichero para las
         dos, así que aquí la única forma de acertar en ambas es partir de la raíz. */
      src: '/media/images/gallery-' + nn + '-t480.webp',
      xl: '/media/images/gallery-' + nn + '-xl.webp',
      alt: 'Pieza de galería ' + n
    };
  });

(function(){
  const grid = document.getElementById('gallery-grid');
  if(!grid) return;

  /* Con 81 fotos, desplegar "todo" se sentía infinito. Se resuelve bajando a un tope
     real: SHOWN_COUNT por tanda, elegidas al azar del banco entero. Antes esa tanda
     solo cambiaba si el visitante recargaba la página a mano — el aviso de texto que
     lo explicaba ("si actualizas...") ha desaparecido porque ahora lo hace el propio
     botón: primer clic despliega, clics siguientes renuevan la tanda sin repetir
     ninguna foto de la que se acaba de ver (ver pickBatch). */
  const SHOWN_COUNT = Math.min(32, GALLERY_ITEMS.length);

  function barajar(arr){
    const a = arr.slice();
    for(let i = a.length - 1; i > 0; i--){
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  /* Con 95 fotos en el banco (TOTAL_PHOTOS menos EXCLUDED_PHOTOS) y 32 por tanda,
     siempre quedan 63 sin usar — de sobra para una tanda entera sin tocar ninguna de
     las que se acaban de mostrar. Si el banco bajara alguna vez por debajo de 64
     fotos, ya no alcanzaría para una tanda 100% distinta; en ese caso se completa con
     las menos repetidas posibles en vez de romper el botón. */
  function pickBatch(excluir){
    const resto = GALLERY_ITEMS.filter(it => !excluir.has(it));
    let elegidas = barajar(resto).slice(0, SHOWN_COUNT);
    if(elegidas.length < SHOWN_COUNT){
      const relleno = barajar(GALLERY_ITEMS.filter(it => excluir.has(it)));
      elegidas = elegidas.concat(relleno.slice(0, SHOWN_COUNT - elegidas.length));
    }
    return elegidas;
  }

  let shown = pickBatch(new Set());
  let lastOpenedIdx = 0;

  function navGet(fromIdx, dir){
    if(!shown.length) return null;
    const pos = (fromIdx + dir + shown.length) % shown.length;
    lastOpenedIdx = pos;
    const it = shown[pos];
    return { src: it.xl || it.src, alt: it.alt || '' };
  }

  /* Pinta una tanda entera desde cero — se usa tanto en la carga inicial como en cada
     renovación, para no duplicar la creación de <img>/placeholder en dos sitios. */
  function pintarTanda(){
    grid.innerHTML = '';
    shown.forEach((item, i) => {
      if(item.src){
        const img = document.createElement('img');
        img.loading = 'lazy'; img.decoding = 'async';
        img.src = item.src; img.alt = item.alt || '';
        img.addEventListener('mouseenter',()=>cursor.classList.add('big'));
        img.addEventListener('mouseleave',()=>cursor.classList.remove('big'));
        img.addEventListener('click', () => {
          lastOpenedIdx = i;
          openImgLightbox(item.xl || item.src, item.alt, img, { get: dir => navGet(lastOpenedIdx, dir) });
        });
        grid.appendChild(img);
      } else {
        const div = document.createElement('div');
        div.className = 'gallery-ph';
        div.setAttribute('aria-hidden','true');
        div.textContent = String(i + 1).padStart(2,'0');
        grid.appendChild(div);
      }
    });
  }
  pintarTanda();

  /* Primer clic: "Desplegar galería" quita el max-height y revela las 32 fotos ya
     cargadas, sin navegar a ningún sitio. A partir de ahí el mismo botón pasa a
     renovar la tanda (etiqueta "gal-more-again"): se sustituye por completo, sin
     repetir ninguna de las que se acaban de ver, y el botón sigue ahí para volver a
     pulsarlo tantas veces como se quiera. */
  const moreBtn = document.getElementById('gallery-more-btn');
  const fade = document.getElementById('gallery-fade');
  if(moreBtn){
    let desplegada = false;
    moreBtn.addEventListener('click', () => {
      if(!desplegada){
        desplegada = true;
        grid.classList.add('expanded');
        moreBtn.setAttribute('aria-expanded','true');
        if(fade) fade.classList.add('hidden');
        moreBtn.dataset.ev = 'galeria-otra-tanda';
        const label = moreBtn.querySelector('[data-wk]');
        if(label){
          label.dataset.wk = 'gal-more-again';
          const t = TRANSLATIONS[document.documentElement.lang === 'en' ? 'en' : 'es'] || {};
          label.textContent = t['gal-more-again'] || 'Ver otra selección →';
        }
        return;
      }
      shown = pickBatch(new Set(shown));
      pintarTanda();
      grid.scrollIntoView({ block: 'nearest' });
    });
  }

  /* Antes el límite salía de una fórmula de vw en CSS asumiendo casillas 1:1; con
     fotos 3:4 (más altas) esa fórmula ya no cuadra, y cualquier proporción futura
     la volvería a romper. Se mide el alto real de una casilla ya en pantalla y se
     calculan N filas a partir de ahí — funciona con cualquier proporción sin tocar
     CSS. 2 filas visibles: con 4 se veía demasiado de golpe antes de desplegar. */
  const VISIBLE_ROWS = 2;
  function collapseHeight(){
    if(grid.classList.contains('expanded')) return;
    const first = grid.firstElementChild;
    if(!first) return;
    const tileH = first.getBoundingClientRect().height;
    if(!tileH) return;
    const gap = parseFloat(getComputedStyle(grid).rowGap) || 0;
    grid.style.maxHeight = Math.round(VISIBLE_ROWS * tileH + (VISIBLE_ROWS - 1) * gap) + 'px';
  }
  collapseHeight();

  /* Restauración propia del scroll: la decisión ya se tomó al principio del
     fichero (ver comentario junto a `beforeunload`); aquí solo se ejecuta,
     porque es cuando el grid ya está pintado y medido. */
  if(window._wwScrollRestore && window._wwScrollRestore.inGallery){
    grid.closest('section').scrollIntoView({block:'start'});
  }

  let resizeT;
  window.addEventListener('resize', () => {
    clearTimeout(resizeT);
    resizeT = setTimeout(collapseHeight, 150);
  }, {passive:true});
})();

/* El carrusel "antes de la IA" se retiró con el rediseño: aquel bloque era una sola
   casilla con flechas que solo cambiaban un número, dentro de la columna central de
   #nosotros. Ahora es la sección #antes-ia, con cuatro piezas visibles a la vez y sin
   navegación — un archivo se enseña, no se pasa de uno en uno. */

/* ── magnetic buttons ── */
(function(){
  /* 0.38 desplazaba el botón tanto que se fallaba el clic. 0.12 conserva el efecto
     sin mover el objetivo fuera del cursor. */
  const STRENGTH=0.12;
  function init(btn){
    let cx=0,cy=0,raf=false,lastDx=0,lastDy=0;
    btn.addEventListener('mouseenter',()=>{
      const r=btn.getBoundingClientRect();
      cx=r.left+r.width/2;cy=r.top+r.height/2;
    });
    btn.addEventListener('mousemove',e=>{
      lastDx=e.clientX-cx;lastDy=e.clientY-cy;
      if(!raf){
        raf=true;
        requestAnimationFrame(()=>{btn.style.transform='translate3d('+(lastDx*STRENGTH)+'px,'+(lastDy*STRENGTH)+'px,0)';raf=false;});
      }
    },{passive:true});
    btn.addEventListener('mouseleave',()=>{btn.style.transform='translate3d(0,0,0)';});
  }
  document.querySelectorAll('.btn-liquid,.btn-metal,.nav-cta').forEach(init);
})();

/* ── nav lamp ── */
const pillLinks=document.querySelectorAll('.pill a');
const lamp=document.getElementById('navlamp');
function moveLamp(el){
  if(!el)return;
  const pr=el.closest('.pill').getBoundingClientRect();
  const er=el.getBoundingClientRect();
  lamp.style.width=er.width+'px';
  lamp.style.transform='translateX('+(er.left-pr.left-5)+'px)';
}
window.addEventListener('load',()=>moveLamp(pillLinks[0]));
pillLinks.forEach(a=>a.addEventListener('mouseenter',()=>moveLamp(a)));
document.querySelector('.pill')?.addEventListener('mouseleave',()=>{const act=document.querySelector('.pill a.active');moveLamp(act||pillLinks[0]);});

/* ── DRIVER ÚNICO DE SCROLL ───────────────────────────────────────────────────
   Antes había tres listeners de scroll independientes (barra de progreso, fundido
   del hero y sección activa del nav), cada uno con su propio rAF. Los tres leían
   geometría en cada frame —scrollHeight, offsetTop de 6 secciones y dos
   getBoundingClientRect— y esas lecturas fuerzan al navegador a recalcular el
   layout justo después de haber escrito estilos: es el patrón clásico que produce
   los tirones al hacer scroll.

   Ahora: un solo listener, un solo rAF, y toda la geometría medida fuera del bucle.
   ───────────────────────────────────────────────────────────────────────────── */
(function(){
  const pin=document.getElementById('hero-pin');
  const heroEl=document.getElementById('hero');
  const desktopHero=window.innerWidth>760;

  /* El nav va a incorporar un enlace a /portfolio (fuera de la página, sin ancla).
     document.querySelector(href) con un href que no empiece por "#" lanza excepción
     — no falla en silencio, para el script entero, incluida la barra de progreso y
     el estado activo del resto del nav. El filtro por "#" tiene que ir ANTES del
     querySelector, no después. */
  const navSections=Array.from(pillLinks)
    .filter(a=>(a.getAttribute('href')||'').startsWith('#'))
    .map(a=>({a,el:document.querySelector(a.getAttribute('href'))}))
    .filter(s=>s.el);

  let fadeDist=1, tops=[], activeIdx=-1;
  const _hitosScroll=[25,50,75,90];   /* se van consumiendo: cada uno se envía una vez */

  function measure(){
    measureScrollRange();
    if(heroEl) fadeDist=Math.max(heroEl.offsetHeight,1);
    tops=navSections.map(s=>s.el.offsetTop);   // se leen una vez, no en cada frame
  }

  function update(){
    const y=window.scrollY;

    if(bar) bar.style.width=(y/_scrollRange*100)+'%';

    if(pin && desktopHero){
      const p=Math.min(Math.max(y/fadeDist,0),1);
      pin.style.opacity=1-p;
      /* El blur se ha quitado: animar filter:blur() en un elemento de 100vh obliga
         a rasterizar de nuevo toda la pantalla en cada frame, y era con diferencia
         lo más caro del scroll. Una escala mínima da sensación de profundidad
         parecida y la resuelve el compositor, sin repintar nada. */
      pin.style.transform='scale('+(1-p*0.04)+')';
      pin.style.pointerEvents=p>0.92?'none':'auto';
    }

    /* Profundidad de scroll dentro del driver existente, no en un listener nuevo:
       es lo que dice el README y además esta lectura ya está hecha. Responde a la
       pregunta que más vale de esta web: en qué pantalla se cae la gente. */
    if(_hitosScroll.length){
      const pct=(y+window.innerHeight)/document.body.scrollHeight*100;
      while(_hitosScroll.length && pct>=_hitosScroll[0]){
        wwTrack('scroll',{hasta:_hitosScroll.shift()+'%'});
      }
    }

    if(tops.length){
      /* Se quedaba con el ÚLTIMO enlace del nav cuyo top estuviera por encima de la
         sonda, lo que da por hecho que el orden del menú coincide con el del DOM. Al
         mover una sección y no el enlace, la lámpara se encendía en la sección
         equivocada sin ningún error — el mismo tipo de dependencia posicional
         silenciosa que ya rompió las traducciones. Ahora se elige por posición real. */
      const probe=y+window.innerHeight*0.35;
      let idx=0, best=-Infinity;
      for(let i=0;i<tops.length;i++){ if(tops[i]<=probe && tops[i]>=best){ best=tops[i]; idx=i; } }
      if(idx!==activeIdx){            // solo se toca el DOM cuando cambia de verdad
        activeIdx=idx;
        pillLinks.forEach(a=>a.classList.remove('active'));
        navSections[idx].a.classList.add('active');
        moveLamp(navSections[idx].a);
      }
    }
  }

  let raf=false;
  window.addEventListener('scroll',()=>{
    if(!raf){ raf=true; requestAnimationFrame(()=>{ update(); raf=false; }); }
  },{passive:true});
  window.addEventListener('resize',()=>{ measure(); update(); },{passive:true});
  window.addEventListener('load',()=>{ measure(); update(); });
  /* Las fuentes se cargan de forma asíncrona (truco media="print"). Cuando aplican,
     cambian las métricas de texto y todas las secciones se desplazan, dejando las
     posiciones cacheadas obsoletas: el nav marcaba la sección equivocada hasta el
     primer scroll. Con esto se remide en cuanto la tipografía está lista. */
  if(document.fonts && document.fonts.ready){
    document.fonts.ready.then(()=>{ measure(); update(); });
  }
  measure(); update();
})();


/* ── 3D tilt cards (solo ratón/trackpad real) ──
   Se aplica rotateX/rotateY directamente sobre .team-card, que también lleva
   overflow:hidden y bordes redondeados. En Safari/WebKit esa combinación (transform 3D
   + overflow:hidden en el mismo elemento) rompe el recorte: la imagen se sale del
   recuadro en una cuña diagonal. En táctil además mouseenter/mousemove pueden llegar
   sueltos (sin mouseleave) al tocar, dejando la tarjeta a medio inclinar. Se limita a
   dispositivos con hover real y puntero fino: en táctil nunca se llega a aplicar
   ninguna transformación, así que el bug no puede dispararse. */
if(window.matchMedia('(hover:hover) and (pointer:fine)').matches){
  document.querySelectorAll('[data-tilt]').forEach(card=>{
    let rect=null,raf=false,lastPx=0,lastPy=0;
    card.addEventListener('mouseenter',()=>{rect=card.getBoundingClientRect();});
    card.addEventListener('mousemove',e=>{
      if(!rect)return;
      lastPx=(e.clientX-rect.left)/rect.width-0.5;
      lastPy=(e.clientY-rect.top)/rect.height-0.5;
      if(!raf){
        raf=true;
        requestAnimationFrame(()=>{card.style.transform=`rotateX(${-lastPy*8}deg) rotateY(${lastPx*8}deg) translateZ(0)`;raf=false;});
      }
    },{passive:true});
    card.addEventListener('mouseleave',()=>{card.style.transform='rotateX(0) rotateY(0)';rect=null;});
  });
}


/* Aquí vivía el globo D3 (orthographic, arrastrar para girar): ~278 KB de d3.v7
   más 237 KB de media/data/ne_110m_land.json para decir "trabajamos en remoto",
   algo que ya dice el pie de página en una línea. Sustituido por el bloque de
   fotos pre-IA (.pre-ai-grid en index.html), que demuestra el único diferenciador
   de la web que no tenía ninguna prueba detrás. */

/* ── language popup & translation ── */
const TRANSLATIONS = {
  es: {
    'nav-inicio': 'Inicio',
    'nav-servicios': 'Precios',
    'nav-visuals': 'Vídeo',
    'nav-faq': 'FAQ',
    'nav-estudio': 'Estudio',
    'nav-cta': 'Prueba gratis',
    'hero-eyebrow': 'Para moda, cosmética, joyería y e-commerce',
    'hero-sub': '24 piezas de campaña en cinco días, dirigidas por dos personas que hacían fotografía de moda antes de que la IA existiera. Por 1.200 €: lo que cuesta solo el fotógrafo de una sesión de un día.',
    /* Los 3 CTA de "pedir prueba" incrustados en el contenido (hero, #prueba, CTA
       final) decían los tres exactamente "Pide tu prueba gratis" — quien scrollea
       veía el mismo botón tres veces. Cada uno reforzaba lo mismo en vez de lo que
       tenía alrededor:
       · Hero: primer contacto, cero contexto todavía — se ancla al entregable
         concreto ("3 fotos"), no a la palabra abstracta "prueba".
       · #prueba (trial-cta): llega justo después del proceso en 3 pasos y de "¿la
         trampa?" — ya está convencido, lo que hace falta es que actúe ya ("ahora").
       · CTA final: ha visto precios, equipo y FAQ — es la última oportunidad, y
         encaja con la cuota real ("4 marcas al mes") que ya se menciona en el
         formulario, así que "reserva" no es una palabra suelta.
       Los CTA de navegación (nav, drawer, barra móvil) se dejan igual a propósito:
       son elementos de interfaz persistente, no puntos del recorrido — cambiar su
       texto rompe el "esto es donde siempre está el botón", que es su trabajo. */
    'hero-btn1': 'Mira lo que producimos',
    'hero-btn2': 'Pruébalo gratis',
    'nav-trabajo': 'Galería',
    'svc-eyebrow': 'Elige cómo trabajar con nosotros',
    'svc-h2': 'PRODUCE TU PRÓXIMA <span class="glow-word">campaña</span>',
    'svc-sub': 'Tres formas de trabajar con nosotros, todas con la misma dirección creativa. Eliges por volumen y ritmo, no por calidad.',
    'svc-1-h': 'Sesiones editoriales',
    'svc-1-p': 'Una campaña editorial completa: 24 piezas bajo una misma dirección, en cinco días laborables.',
    'svc-2-h': 'Avatares UGC',
    'svc-2-p': 'Un rostro que presenta tu producto en el idioma y el tono que necesites. Sin caché, sin agencia y sin derechos de imagen que renovar.',
    'svc-3-h': 'E-commerce',
    'svc-3-p': 'Fotografía y vídeo de producto listos para ficha, ads y redes. Adaptados a cada plataforma.',
    'svc-4-h': 'Campañas de ads',
    'svc-4-p': 'Un mismo concepto en diez versiones, listas para que tu gestor de ads las ponga a competir entre sí.',
    'svc-foot': 'Todo se entrega con licencia comercial completa y sin royalties. Los assets son tuyos para siempre.',
    'price-0-tag': 'Pack de arranque',
    'price-0-num': '490 €',
    'price-0-desc': '8 piezas · 5 días laborables',
    'price-0-pos': '<strong>Prueba de capacidad</strong> antes de la campaña completa.',
    'price-0-list': ['Un concepto en 8 piezas','La misma dirección que una campaña completa','Una ronda de ajustes incluida'],
    'price-1-tag': 'Campaña completa',
    'price-1-num': '1.200 €',
    'price-1-desc': '24 piezas · 5 días laborables',
    'price-1-pos': '<strong>Volumen y coherencia</strong> para lanzamientos y drops.',
    'price-1-list': ['Hasta 10 direcciones creativas para testear','Una ronda de ajustes incluida','Si no cumple el brief aprobado, la rehacemos sin coste'],
    'price-2-tag': 'Always-On',
    'price-2-num': '1.500 €<small>/mes</small>',
    'price-2-desc': 'Tu mes de contenido, cubierto',
    'price-2-pos': '<strong>Producción continua</strong> para marcas que publican cada mes.',
    'price-2-list': ['Produces todo el mes sin pedir campaña cada vez','Capacidad reservada: entras antes que cualquier proyecto suelto','Sin permanencia'],
    'price-cta-0': 'Reservar mi pack →',
    'price-cta-1': 'Hablar de Always-On →',
    'svc-band-head': 'En los tres planes',
    'svc-band-text': 'Dirección creativa · cada pieza en los formatos que necesites · retoque humano pieza a pieza · licencia comercial completa, sin royalties',
    'svc-band-head-2': 'Qué es una pieza',
    'svc-band-head-3': '¿Aún no lo tienes claro?',
    'svc-piece-def': 'Un entregable final listo para publicar — foto, vídeo corto o creatividad de campaña. Las adaptaciones de formato de esa misma pieza van incluidas y no cuentan aparte.',
    'price-badge': 'Recomendada',
    'svc-result-head': 'El resultado',
    'svc-result-text': 'Veinticuatro piezas donde antes tenías cinco, y en días donde antes eran semanas. Y una marca que parece bastante más grande de lo que es.',
    'svc-result-label': 'de las piezas entregadas hasta hoy se aprobó sin rehacer. Actualizamos la cifra cada trimestre.',
    'price-0-credit': 'Si contratas la Campaña completa en 30 días, <strong>los 490 € se descuentan enteros</strong>.',
    'price-1-founders': '<strong id="price-month">Septiembre</strong>: <strong>4 plazas</strong>, y se asignan por orden de entrada.',
    'price-2-note': 'Cada mes parte del anterior: el concepto y el estilo <strong>ya están montados</strong>.',
    'cmp-alt-eyebrow': 'Capacidad de producción',
    'cmp-alt-h3': 'MÁS CONTENIDO Y MÁS <span class="glow-word">variantes</span>, en menos tiempo',
    'cmp-alt-intro': 'No es la misma campaña con otro precio: es otra forma de producirla.',
    'cmp-caps-h1': 'Una campaña de moda',
    'cmp-cap-piezas': 'Piezas entregadas', 'cmp-cap-piezas-a': '~20', 'cmp-cap-piezas-b': '24',
    'cmp-cap-formatos': 'Formatos y variantes de cada pieza', 'cmp-cap-formatos-a': 'Se facturan aparte', 'cmp-cap-formatos-b': 'Incluidos',
    'cmp-cap-dir': 'Direcciones creativas que puedes testear', 'cmp-cap-dir-a': '1', 'cmp-cap-dir-b': 'Hasta 10',
    'cmp-cap-plazo': 'Plazo', 'cmp-cap-plazo-a': '5 semanas', 'cmp-cap-plazo-b': '5 días laborables',
    'cmp-cap-rev': 'Revisiones', 'cmp-cap-rev-a': 'Producción nueva', 'cmp-cap-rev-b': '1 ronda incluida',
    'cmp-cap-log': 'Producción y logística', 'cmp-cap-log-a': 'Fotógrafo, modelo, estudio', 'cmp-cap-log-b': 'No hay que montarla',
    'cmp-h2': 'Producción tradicional', 'cmp-h3': 'WORLDWORK',
    'pricing-alt': 'Pruébalo gratis primero →',
    'pricing-alt-note': 'Tres fotos con tu producto en 72 h. Sin tarjeta y sin compromiso.',
    'svc-btn': 'Reservar mi campaña →',
    'hero-alt': '¿Ya lo tienes claro? Agenda una llamada →',
    'formatos-next': '¿Quieres ver más? Portfolio completo →',
    'arch-craft': 'Trabajábamos con modelos, buscábamos localizaciones, montábamos producciones enteras. Sabemos lo que cuesta un día de rodaje porque lo hemos pagado — y sabemos qué parte de todo aquello hay que conservar cuando la cámara desaparece.',
    'arch-eyebrow': 'Antes de la IA',
    'arch-h2': 'EL OJO NO SE <span class="glow-word">genera</span>',
    'arch-lead': 'Dirigíamos fotografía de moda, fashion film y dirección de marca años antes de que la IA generara una sola imagen.',
    'arch-creds': ['Fotografía de moda','Fashion film','Dirección de marca'],
    'arch-note': 'No es nostalgia: es la razón por la que sabemos qué luz, qué encuadre y qué gesto hacen que una pieza generada no se note. Un generador de imágenes no tiene este archivo detrás.',
    'arch-cap': ['Campaña de marca','Editorial de moda','Fotografía de calle','Dirección de estilismo'],
    'arch-next': 'Ese mismo ojo dirige tu campaña. Compruébalo gratis →',
    'work-next': '¿Se nota que está hecho con IA? Te lo explicamos →',
    'trial-alt': '¿Aún con dudas? Léelas resueltas →',
    'hero-line1': 'TU CAMPAÑA',
    'hero-line2': 'EN 5 DÍAS',
    'guarantee': 'Si la primera entrega no cumple el brief que <strong>tú aprobaste</strong>, la rehacemos entera sin coste.',
    'hero-recip': 'Las tres fotos son tuyas, contrates o no.',
    'tell-eyebrow': 'La pregunta que siempre nos hacen',
    'tell-h2': '¿SE NOTA QUE ES <span class="glow-word">ia</span>?',
    'tell-lead': 'Sí, <em>cuando está mal hecha.</em> Por eso revisamos cada pieza hasta que supera a una foto de estudio.',
    'tell-1-h': 'Consistencia entre piezas',
    'tell-1-p': 'Si pides cien imágenes, las cien tienen que parecer de la misma sesión: el mismo producto, la misma luz, el mismo tono de piel. Ahí es donde se cae el contenido IA barato: cada pieza parece de otra marca.',
    'tell-2-h': 'Retoque humano, pieza a pieza',
    'tell-2-p': 'Ningún modelo acierta a la primera con las manos, la textura de un tejido o un logotipo. Corregimos esos detalles a mano en cada imagen, porque son exactamente los que delatan que algo está generado.',
    'tell-3-h': 'Dirección antes que generación',
    'tell-3-p': 'Cerramos el brief contigo antes de generar la primera imagen. La IA no decide cómo se ve tu marca: ejecuta una dirección creativa que ya está tomada. Esa decisión es la parte que no se puede automatizar.',
    'tell-note': 'Y sobre etiquetarlo: <strong>todo lo que producimos es contenido generado con IA</strong>, y te lo entregamos documentado como tal. Si tu mercado te obliga a declararlo, ya tienes el respaldo por escrito. Qué le cuentas a tu audiencia lo decides tú, con toda la información encima de la mesa.',
    'form-alt': '¿Prefieres escribirnos directamente?',
    'form-eyebrow': 'Prueba gratis',
    'form-title': 'Tres fotos con tu producto. <span class="glow-word">gratis</span>',
    'form-sub': 'Solo necesitamos el Instagram de tu marca. Te contesta Andrés o Saúl en persona, en menos de 24 horas laborables.',
    'form-brand-label': 'El Instagram o la web de tu marca',
    'form-brand-ph': '@tumarca',
    'form-email-label': 'Tu email',
    'form-email-ph': 'hola@tumarca.com',
    'form-email-help': 'Aquí te enviamos las tres fotos.',
    'form-name-label': 'Tu nombre',
    'form-name-ph': 'Para no escribirte solo «hola»',
    'form-product-label': '¿Algún producto en concreto?',
    'form-product-label-pack': 'Link del producto que vamos a producir',
    'form-product-ph-pack': 'https://tumarca.com/producto',
    'form-product-ph': 'Si no nos dices ninguno, elegimos nosotros cuál probar',
    'form-optional': 'opcional',
    'form-brief-label': 'La dirección creativa que tienes en la cabeza',
    'form-brief-ph': 'Qué quieres transmitir, qué referencias te gustan, dónde se va a publicar, para cuándo lo necesitas…',
    'form-country-label': 'País',
    'form-country-ph': 'España',
    'form-country-help': 'Nos dice cómo va el IVA en tu factura.',
    'err-country': 'Dinos el país: de ahí depende cómo va el IVA.',
    'form-legal': 'Al enviar aceptas nuestra <a href="privacidad.html" target="_blank" rel="noopener">política de privacidad</a>. Usamos tus datos para responderte, y para nada más.',
    'form-phone-label': 'Teléfono',
    'form-phone-opt': 'opcional',
    'form-phone-ph': '+34 600 000 000',
    'form-phone-help': 'Solo para lo urgente de tu proyecto. No hacemos llamadas comerciales.',
    'form-prev': 'Atrás',
    'form-next': 'Siguiente',
    'form-step-1': 'Tu marca',
    'form-step-2': 'La idea',
    'form-step-3': 'Contacto',
    'err-product': 'Ponnos el enlace del producto que quieres producir.',
    'err-phone': 'Revisa el teléfono: nos falta algún dígito.',
    'err-name': 'Dinos a nombre de quién va la factura.',
    /* la nota del paso 2 y la caja de la pantalla final: el destino real sale de
       DESTINO_ASSETS, aquí solo va el texto que lo acompaña */
    'form-assets-nota': '¿Tienes fotos de producto o referencias? No hacen falta aquí. Al terminar te decimos dónde mandarlas.',
    'form-assets-nota-pack': 'Las fotos de producto y las referencias no se suben aquí: al terminar te damos la dirección a la que enviarlas.',
    'ty-assets-head': 'Mándanos tus fotos y referencias',
    'ty-assets-body': 'Si tienes fotos de producto, referencias o un moodboard, envíalos aquí y empezamos antes:',
    'ty-assets-body-pack': 'Escríbenos a esta dirección con las fotos de tu producto y cualquier referencia. Es lo único que nos falta para arrancar:',
    'ty-assets-fine': 'Si no tienes nada a mano, no pasa nada: tiramos de lo que haya público en tu perfil.',
    'ty-assets-cta': 'Subir mis archivos →',
    'form-submit': 'Pedir mis tres fotos',
    'form-sending': 'Enviando…',
    'form-fine': 'Sin tarjeta y sin compromiso. Las fotos son tuyas contrates o no.',
    /* ── cara "pack": la abre el CTA del Pack de arranque (ver CARAS_CTA). Solo redefine lo que
       cambia; los rótulos de los campos, los placeholders y "Enviando…" se heredan. */
    'form-eyebrow-pack': 'Pack de arranque · 490 €',
    'form-title-pack': 'Reserva tu pack de <span class="glow-word">8 piezas</span>',
    'form-sub-pack': 'Dinos dónde mirar y te contestamos el mismo día laborable con lo que vamos a producir, la fecha de entrega y el enlace de pago. Te escribe Andrés o Saúl, no un comercial.',
    'form-email-help-pack': 'Aquí te enviamos la propuesta y el enlace de pago.',
    'form-quota-pack': 'Cinco días laborables de producción desde que confirmas. Si contratas la <strong>Campaña completa</strong> en los 30 días siguientes, los 490 € se te descuentan enteros.',
    'form-submit-pack': 'Reservar mi pack',
    'form-fine-pack': 'No se cobra nada ahora. Confirmas tú, después de ver qué vamos a producir.',
    'form-quota': 'Aceptamos <strong>4 marcas al mes</strong>. Miramos cada una antes de decir que sí, y si no la vemos clara te lo decimos el mismo día.',
    'err-brand': 'Necesitamos esto para ver tu producto. Nos vale un @ o una dirección web.',
    'err-email': 'Revisa el email, parece que le falta algo.',
    'form-error': 'No hemos podido enviarlo. Escríbenos y te respondemos igual de rápido:',
    'form-mailto': 'Te hemos abierto el correo con todo escrito: solo tienes que darle a enviar.',
    'form-mailto-link': 'Abrirlo de nuevo',
    'formatos-sub': 'Cinco formatos, una sola dirección creativa. Del vídeo de marca al reel vertical que parece grabado con un móvil.',
    'band2-text': 'Dinos qué marca llevas y te decimos qué haríamos con ella.',
    'band2-small': 'Veinte minutos por vídeo con Andrés o Saúl. Sales con una idea concreta de qué haríamos con tu marca.',
    'band2-btn': 'Cuéntanos qué marca llevas →',
    'mob-cta': 'Pide tu prueba gratis',
    'mob-cta-note': '3 fotos para tu marca · sin compromiso',
    'trial-eyebrow': 'Antes de pagar nada',
    'trial-h2': 'PRUÉBALO CON TU <span class="glow-word">marca</span>',
    'trial-lead': 'Compruébalo con tu propio producto. <strong>Tres fotos, en 72 horas, gratis.</strong>',
    'trial-1-h': 'Nos das tu Instagram',
    'trial-1-p': 'Nada más. Ni fotos, ni brief, ni llamada.',
    'trial-2-h': 'Dirigimos y producimos',
    'trial-2-p': 'Un concepto para tu marca y tres fotos que lo desarrollan: misma luz, mismo mundo.',
    'trial-3-h': 'Las recibes en 72 horas',
    'trial-3-p': 'Listas para publicar. Son tuyas, contrates o no.',
    'trial-why': '<strong>¿Por qué gratis?</strong> Porque enseñarte tu propio producto convence más que cualquier cosa que podamos escribir aquí. Nos cuesta medio día. Si funciona, ganamos un cliente; si no, tú te quedas las fotos. Solo aceptamos <strong>4 marcas nuevas al mes</strong>, y solo si vemos claro que podemos superar lo que ya tienen — sin lista de espera: si tienes un drop o una campaña con fecha, cuanto antes lo digas, antes empieza.',
    'trial-cta': 'Empieza tu prueba ahora',
    'trial-fine': 'Sin tarjeta · sin compromiso',
    'faq-q8': '¿La prueba gratis tiene truco?',
    'faq-a8': '<p>No. No pedimos tarjeta, no hay suscripción que se active después y no te comprometes a nada. Te damos <strong>tres fotos producidas con tu producto</strong> y son tuyas aunque no vuelvas a escribirnos.</p><p>Lo hacemos porque somos un estudio nuevo: nos sale más rentable demostrarte el nivel con tu marca que intentar convencerte por escrito. Tú te llevas contenido publicable; nosotros, un caso que enseñar. Lo único que pedimos es tu web o tu Instagram.</p><p>Si las fotos te convencen, hablamos de la campaña completa. Si no, no pasa nada: no hay seguimiento ni te metemos en ninguna lista de correo.</p>',
    'faq-q10': '¿Puedo hablar con alguien antes de decidir?',
    'faq-a10': 'Sí. Agenda una llamada de 20 minutos con quien va a dirigir tu proyecto, no con un comercial. Te enseñamos ejemplos parecidos a tu sector y resolvemos dudas antes de que pidas nada — no hace falta pasar por la prueba gratis primero. De esa llamada no sales con un precio improvisado: cuando entendemos qué necesitas, te mandamos la propuesta por escrito, con el alcance y el precio cerrados.',
    'faq-q11': '¿Podéis sostener producción continua siendo solo dos?',
    'faq-a11': 'Sí, y la razón es la misma que hace que el precio tenga sentido: el primer mes montamos el concepto y el estilo de tu marca; a partir del segundo, cada entrega parte de esa base en vez de empezar de cero. No son conceptos nuevos cada mes — son variaciones de uno ya definido, y eso es lo que hace que el ritmo sea sostenible. Por eso Always-On no se vende por número de piezas: el volumen que sale de un concepto ya montado no es el mismo que el de empezar de cero, y preferimos acordarlo contigo que ponerte una cifra en una tarjeta.',
    'formatos-eyebrow': 'Vídeo',
    'formatos-h2': 'UN FORMATO PARA<br>CADA CAMPAÑA',
    'vid-cat-1': 'Editorial de campaña',
    'vid-title-1': 'Vídeo editorial',
    'vid-desc-1': 'Movimiento con el ritmo y la composición de una editorial de moda: el vídeo con el que abres campaña, no el que la acompaña.',
    'vid-cat-2': 'Editorial de campaña',
    'vid-title-2': 'Campaña de ads',
    'vid-desc-2': 'Varias variantes de una misma creatividad, generadas a velocidad IA para testear direcciones sin esperar semanas de producción.',
    'vid-cat-3': 'Producto / E-commerce',
    'vid-title-3': 'Vídeo de producto',
    'vid-desc-3': 'Planos de detalle para producto premium: la textura, el brillo y el peso del objeto, en movimiento.',
    'vid-cat-4': 'Avatares UGC',
    'vid-title-4': 'Avatar UGC',
    'vid-desc-4': 'Avatares hiperrealistas que presentan tu producto en vertical, con la naturalidad del contenido real y no la de un anuncio.',
    'vid-cat-5': 'Editorial de campaña',
    'vid-title-5': 'Campaña cinematográfica',
    'vid-desc-5': 'Movimiento fluido, atmósfera y escala de producción de gran formato.',
    'why-eyebrow': 'Antes de ver el precio',
    'why-h2': 'POR QUÉ <span class="glow-word">WORLDWORK</span>',
    'why-sub': 'Para marcas que ya se han quedado pequeñas para las fotos que se hacen ellas mismas. Todo el mundo tiene las mismas herramientas — la diferencia está en quién decide qué generar.',
    'diff-typed-1': 'UN BANCO DE PIEZAS, NO UN VÍDEO SUELTO',
    'diff-desc-1': 'Te llevas cada pieza ya cortada en todos los formatos que necesites, no un archivo suelto que tienes que adaptar tú después.',
    'diff-typed-3': 'HECHO PARA VENDER',
    'diff-desc-3': 'Cada pieza sale ya en los formatos y proporciones que tu gestor de ads te va a pedir el lunes.',
    'diff-typed-5': 'DE SEMANAS A DÍAS',
    'diff-desc-5': 'Lo que otros tardan cinco semanas en entregar, nosotros en cinco días. Cada una de esas semanas es una semana más anunciando el mismo contenido.',
    'diff-typed-6': '10 VARIANTES DONDE OTROS HACEN UNA',
    'diff-desc-6': 'Pruebas diez direcciones en el tiempo que antes costaba producir una sola.',
    /* 'why-tagline' retirada: la frase era un bumerán y su elemento ya no existe. */
    /* "Softwares" no existe en español, y "N8N · Claude" es jerga de herramienta que a
       una marca de moda no le dice nada: nombra el cómo, no el qué. */
    'pre-ai-eyebrow': 'Antes de la IA',
    'pre-ai-text': 'Esto es lo que dirigíamos antes de que la IA generara una sola imagen: sesiones de moda, fashion film, dirección de marca. No es historia — es la razón por la que sabemos qué luz, qué encuadre y qué gesto hacen que una pieza generada no se note. Un generador de imágenes no tiene ese archivo detrás. Nosotros sí — y es lo que hace que tu marca se vea como si llevara detrás un estudio, no una suscripción.',
    'faq-eyebrow': 'Preguntas frecuentes',
    'faq-sub': 'Antes de ver qué puedes contratar, esto es lo que más nos preguntan.',
    'faq-q1': '¿Las imágenes o vídeos generados por WORLDWORK son hechos con IA?',
    /* Había tres versiones incompatibles de esta respuesta: la FAQ decía "completamente
       generado", la sección "¿Se nota la IA?" decía que se retoca a mano y el aviso
       legal decía "total o parcialmente". Esta formulación es la única compatible con
       las tres, y es además la que aguanta que la lea un abogado. */
    'faq-a1': '<p>Sí, y lo decimos sin rodeos: <strong>la imagen se genera con IA</strong>. Lo que no se genera es la decisión. La dirección creativa, la selección de tomas y el retoque final —manos, texturas, logotipos, caída del tejido— los hacemos nosotros, a mano y pieza a pieza.</p><p>Producción generativa con dirección, revisión y postproducción humanas: eso es lo que da consistencia de escena, textura real e iluminación fiel en una fracción del tiempo y del coste de una sesión de estudio.</p>',
    'faq-q9': '¿Mi producto va a salir exactamente como es?',
    'faq-a9': '<p>Es la pregunta correcta, y la respuesta cambia según la fase.</p><p>En la <strong>prueba gratis</strong> partimos solo de lo que hay público en tu Instagram: el producto sale reconocible, pero es una muestra de dirección y de nivel, no una ficha de producto.</p><p>En un <strong>proyecto de verdad</strong> trabajamos con tus fotos y referencias reales. El producto no se inventa: se recompone en una escena nueva. Donde la referencia es exigente —una pieza de joyería, un envase con tipografía, un logotipo— cotejamos y corregimos a mano cada imagen contra el original, y ese cotejo forma parte de la entrega, no es un extra.</p><p>Y si vemos que no podemos garantizar la fidelidad que tu producto necesita, te lo decimos antes de empezar en lugar de entregarte algo aproximado.</p>',
    'faq-q3': '¿Qué diferencia a WORLDWORK de una agencia tradicional, otro estudio de IA, o hacerlo yo mismo?',
    'faq-a3': '<p>Con una agencia pagas horas: fotógrafo, modelo, estilista, localización y postproducción, y de ahí sale <strong>una</strong> dirección creativa. Si no funciona en anuncios, empiezas de cero y pagas otra vez.</p><p>Con IA generativa puede producir cualquiera hoy, incluido tú — la herramienta ya no es la diferencia. Lo que cambia con nosotros es el ojo entrenado detrás: sabemos qué hace que una imagen generada se lea como real y no como IA — luz, proporciones, texturas — y retocamos a mano lo que el modelo no resuelve solo.</p><p>Cerramos un brief de marca contigo antes de generar nada, producimos diez variantes del mismo concepto y las entregamos en los formatos que necesita tu ads manager. En cinco días, y por menos de lo que cuesta solo el fotógrafo.</p><p>Y no depende de que te sientes tú a producir entre reuniones: es nuestro trabajo a tiempo completo.</p>',
    'faq-q12': '¿Cómo funciona el pago?',
    'faq-a12': 'Un depósito inicial reserva la producción. Antes de generar nada te proponemos varios conceptos creativos dentro del brief aprobado y eliges el que más te convence. El resto lo pagas solo cuando la entrega final está completa y en tus manos — no antes.',
    'faq-q5': '¿Cuántas fases incluye el servicio y quién se queda con los derechos?',
    'faq-a5': '<p>Incluye cinco fases desde la petición hasta la entrega final.</p><p><strong>FASE 1:</strong> Empezamos analizando tu marca a fondo: referencias visuales, competencia, qué funciona y qué no.</p><p><strong>FASE 2:</strong> De ahí construimos un brief creativo que defines y apruebas tú antes de que toquemos nada. Sin brief cerrado no hay producción, y eso nos protege a los dos.</p><p><strong>FASE 3:</strong> Producción. Trabajamos del tirón, sin reuniones de seguimiento que no aportan nada: el brief ya está cerrado. Si algo cambia el rumbo, te avisamos ese mismo día. Para todo lo demás, la próxima vez que sepas de nosotros es con la entrega completa en la mano.</p><p><strong>FASE 4:</strong> Cuando está listo, recibes la primera entrega completa. Tienes 48 horas para consolidar todos los comentarios y hacemos los ajustes en una sola ronda. Y si la entrega no cumple el brief que aprobaste en la Fase 2, la rehacemos entera sin coste y sin discusión — la única condición es que el desacuerdo sea con ese brief, no con un cambio de dirección posterior, que eso ya es una campaña nueva.</p><p><strong>FASE 5:</strong> Entrega final ya cortada en los formatos que necesitas: <strong>1:1 y 4:5</strong> para Meta, <strong>9:16</strong> para Reels y TikTok, y la versión larga para tu ficha de Shopify o Amazon. Licencia comercial completa desde ese momento.</p><p>Sin royalties, sin restricciones, sin letra pequeña. Los assets son tuyos <strong>PARA SIEMPRE</strong>.</p>',
    'faq-q6': '¿Con qué tipo de marcas trabajáis?',
    'faq-a6': 'Moda, cosmética, joyería y e-commerce, sobre todo. Ahí es donde tenemos el ojo entrenado y donde vamos a ser mejores que tu alternativa actual. Si tu marca está fuera de esos sectores, escríbenos igual, pero solo aceptamos el proyecto si estamos seguros de que podemos hacerlo mejor que quien lo esté haciendo ahora.',
    'cta-h2': 'RESERVA TU CAMPAÑA DE <span class="glow-word" id="cta-month">SEPTIEMBRE</span>',
    'cta-sub': '24 piezas en cinco días por 1.200 €. Cerramos cuatro marcas al mes: cuéntanos la tuya en veinte minutos y te mandamos la propuesta por escrito.',
    'cta-btn1': 'Reservar mi campaña →',
    'cta-btn2': 'Ver portfolio',
    'cta-alt': '¿Prefieres verlo antes? Pide tus 3 fotos gratis →',
    /* Nombres de mes para el titular del cierre. Van en el diccionario y no en una
       llamada a toLocaleString porque el idioma de la página no tiene por qué coincidir
       con el del navegador: en/index.html se sirve a un navegador español y saldría
       "SEPTIEMBRE" en la versión inglesa. */
    'meses': ['ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE'],
    'ticker-1': 'EDITORIAL DE CAMPAÑA', 'ticker-2': 'PRODUCTO / E-COMMERCE', 'ticker-3': 'AVATARES UGC',
    /* #trabajo: no estaba traducido en absoluto — con los placeholders no se notaba,
       pero en cuanto hay copy real la versión inglesa lo mostraría en español. */
    'gal-eyebrow': 'Galería',
    'gal-h2': 'ESTO ES LO QUE ENTREGAMOS EN <span class="glow-word">CINCO DÍAS</span>',
    'gal-more': 'Desplegar galería →',
    'gal-more-again': 'Ver otra selección →',
    'footer-svc-1': 'Editorial de campaña', 'footer-svc-2': 'Producto / E-commerce', 'footer-svc-3': 'Avatares UGC',
    'footer-tagline': 'Campañas de moda en 5 días. Sin estudio y sin lista de espera.',
    'footer-col-1': 'Servicios',
    'footer-col-2': 'Contacto',
    'footer-col-3': 'Legal',
    'footer-copy': '© 2026 WORLDWORK Studio. Todos los derechos reservados.',
    'footer-location': 'MURCIA, ESPAÑA · ALCANCE GLOBAL',
    'cta-mono-tagline': 'WORLDWORK · ESTUDIO DE CONTENIDO IA · MURCIA',
    'skip-link': 'Saltar al contenido',
    'ty-eyebrow': 'Solicitud recibida',
    'ty-title': 'GRACIAS POR<br>CONFIAR EN <span>WORLD<span class="ty-work">WORK</span></span>',
    'ty-sub': 'Hemos recibido tu solicitud. La leemos personalmente Andrés o Saúl. No hay filtros ni intermediarios. Tendrás respuesta en menos de 24 horas laborables.',
    'ty-step1-h': 'Analizamos tu marca',
    'ty-step1-p': 'Miramos tu web y tu Instagram: producto, paleta y tono. De ahí sale el concepto de tu prueba.',
    'ty-step2-h': 'Te confirmamos',
    'ty-step2-p': 'Te decimos si la aceptamos y qué vamos a producir. Si no la vemos clara, te lo decimos sin rodeos.',
    'ty-step3-h': 'Fotos en 72h',
    'ty-step3-p': 'Recibes tus tres fotos en alta y en formato de Instagram. Sin coste y sin compromiso de seguir.',
    /* pantalla de gracias, cara "pack" */
    'ty-step1-p-pack': 'Miramos tu web y tu Instagram: producto, paleta y tono. De ahí sale el concepto de tus 8 piezas.',
    'ty-step2-h-pack': 'Te mandamos la propuesta',
    'ty-step2-p-pack': 'Qué vamos a producir, la fecha de entrega y el enlace de pago. Si no vemos claro que podamos superar lo que ya tienes, te lo decimos y no cobramos nada.',
    'ty-step3-h-pack': 'Entrega en 5 días',
    'ty-step3-p-pack': 'Desde que confirmas: 8 piezas con una ronda de ajustes incluida.',
    'ty-btn1': 'Volver al inicio →',
    'ty-btn2': 'Ver nuestro trabajo →',
  },
  en: {
    'nav-inicio': 'Home',
    'nav-servicios': 'Pricing',
    'nav-visuals': 'Video',
    'nav-faq': 'FAQ',
    'nav-estudio': 'Studio',
    'nav-cta': 'Free test',
    'hero-eyebrow': 'For fashion, beauty, jewellery and e-commerce',
    'hero-sub': '24 campaign pieces in five days, directed by two people who were shooting fashion photography before AI existed. For €1,200: what the photographer alone costs on a one-day shoot.',
    'hero-btn1': 'See what we produce',
    'hero-btn2': 'Try it free',
    'nav-trabajo': 'Gallery',
    'svc-eyebrow': 'Choose how to work with us',
    'svc-h2': 'PRODUCE YOUR NEXT <span class="glow-word">campaign</span>',
    'svc-sub': 'Three ways to work with us, all under the same creative direction. You choose by volume and pace, not quality.',
    'svc-1-h': 'Editorial sessions',
    'svc-1-p': 'A complete editorial campaign: 24 pieces under one direction, in five business days.',
    'svc-2-h': 'UGC avatars',
    'svc-2-p': 'A face that presents your product in the language and tone you need. No fee, no agency, no image rights to renew.',
    'svc-3-h': 'E-commerce',
    'svc-3-p': 'Product photography and video ready for listings, ads and social. Adapted to each platform.',
    'svc-4-h': 'Ad campaigns',
    'svc-4-p': 'One concept in ten versions, ready for your ads manager to run against each other.',
    'svc-foot': 'Everything ships with full commercial licence and no royalties. The assets are yours forever.',
    'price-0-tag': 'Starter pack',
    'price-0-num': '€490',
    'price-0-desc': '8 pieces · 5 business days',
    'price-0-pos': '<strong>A capability test</strong> before the full campaign.',
    'price-0-list': ['One concept across 8 pieces','The same direction as a full campaign','One round of adjustments included'],
    'price-1-tag': 'Full campaign',
    'price-1-num': '€1,200',
    'price-1-desc': '24 pieces · 5 business days',
    'price-1-pos': '<strong>Volume and coherence</strong> for launches and drops.',
    'price-1-list': ['Up to 10 creative directions to test','One round of adjustments included','If it misses the approved brief, we redo it at no cost'],
    'price-2-tag': 'Always-On',
    'price-2-num': '€1,500<small>/month</small>',
    'price-2-desc': 'Your month of content, covered',
    'price-2-pos': '<strong>Continuous production</strong> for brands that publish every month.',
    'price-2-list': ['You publish all month without commissioning a campaign each time','Reserved capacity: you go ahead of any one-off project','No lock-in'],
    'price-cta-0': 'Book my pack →',
    'price-cta-1': 'Talk about Always-On →',
    'svc-band-head': 'In all three plans',
    'svc-band-text': 'Creative direction · every piece in the formats you need · human retouching piece by piece · full commercial licence, no royalties',
    'svc-band-head-2': 'What a piece is',
    'svc-band-head-3': 'Still not sure?',
    'svc-piece-def': 'A final, publishable deliverable — a photo, a short video or a campaign creative. Format adaptations of that same piece are included and are not counted separately.',
    'price-badge': 'Recommended',
    'svc-result-head': 'The result',
    'svc-result-text': 'Twenty-four pieces where you used to get five, in days instead of weeks. And a brand that looks a good deal bigger than it is.',
    'svc-result-label': 'of the pieces delivered so far were approved with no redo. We update the figure every quarter.',
    'price-0-credit': 'Book the Full campaign within 30 days and <strong>the full €490 is deducted</strong>.',
    'price-1-founders': '<strong id="price-month">September</strong>: <strong>4 slots</strong>, assigned in order of arrival.',
    'price-2-note': 'Each month builds on the last: the concept and the style <strong>are already set up</strong>.',
    'cmp-alt-eyebrow': 'Production capacity',
    'cmp-alt-h3': 'MORE CONTENT AND MORE <span class="glow-word">variants</span>, in less time',
    'cmp-alt-intro': 'It is not the same campaign at a different price: it is a different way of producing it.',
    'cmp-caps-h1': 'A fashion campaign',
    'cmp-cap-piezas': 'Pieces delivered', 'cmp-cap-piezas-a': '~20', 'cmp-cap-piezas-b': '24',
    'cmp-cap-formatos': 'Formats and variants of each piece', 'cmp-cap-formatos-a': 'Billed separately', 'cmp-cap-formatos-b': 'Included',
    'cmp-cap-dir': 'Creative directions you can test', 'cmp-cap-dir-a': '1', 'cmp-cap-dir-b': 'Up to 10',
    'cmp-cap-plazo': 'Turnaround', 'cmp-cap-plazo-a': '5 weeks', 'cmp-cap-plazo-b': '5 business days',
    'cmp-cap-rev': 'Revisions', 'cmp-cap-rev-a': 'A new production', 'cmp-cap-rev-b': '1 round included',
    'cmp-cap-log': 'Production and logistics', 'cmp-cap-log-a': 'Photographer, model, studio', 'cmp-cap-log-b': 'Nothing to set up',
    'cmp-h2': 'Traditional production', 'cmp-h3': 'WORLDWORK',
    'pricing-alt': 'Try it for free first →',
    'pricing-alt-note': 'Three photos with your product in 72 h. No card, no commitment.',
    'svc-btn': 'Book my campaign →',
    'hero-alt': 'Already decided? Book a call →',
    'formatos-next': 'Want to see more? Full portfolio →',
    'arch-craft': 'We worked with models, scouted locations, ran full productions. We know what a shoot day costs because we have paid for it — and we know which part of all that has to survive when the camera disappears.',
    'arch-eyebrow': 'Before AI',
    'arch-h2': 'THE EYE IS NOT <span class="glow-word">generated</span>',
    'arch-lead': 'We were directing fashion photography, fashion film and brand direction years before AI generated a single image.',
    'arch-creds': ['Fashion photography','Fashion film','Brand direction'],
    'arch-note': 'This is not nostalgia: it is why we know which light, which framing and which gesture keep a generated piece from looking generated. An image generator has no archive behind it.',
    'arch-cap': ['Brand campaign','Fashion editorial','Street photography','Styling direction'],
    'arch-next': 'That same eye directs your campaign. See it free →',
    'work-next': 'Can you tell it was made with AI? Here is how we handle it →',
    'trial-alt': 'Still unsure? Read the answers →',
    'hero-line1': 'YOUR CAMPAIGN',
    'hero-line2': 'IN 5 DAYS',
    'guarantee': 'If the first delivery does not meet the brief <strong>you approved</strong>, we redo it entirely at no cost.',
    'hero-recip': 'The three photos are yours, whether you book or not.',
    'tell-eyebrow': 'The question we always get',
    'tell-h2': 'DOES IT LOOK LIKE <span class="glow-word">ai</span>?',
    'tell-lead': 'Yes, <em>when it is badly made.</em> That is why we review every piece until it beats a studio shot.',
    'tell-1-h': 'Consistency across pieces',
    'tell-1-p': 'If you order a hundred images, all hundred have to look like the same shoot: same product, same light, same skin tone. That is exactly where cheap AI content falls apart: every piece looks like a different brand.',
    'tell-2-h': 'Human retouching, piece by piece',
    'tell-2-p': 'No model gets hands, fabric texture or a logo right on the first pass. We fix those details by hand on every image, because they are precisely what gives generated content away.',
    'tell-3-h': 'Direction before generation',
    'tell-3-p': 'We close the brief with you before the first image is generated. AI does not decide how your brand looks: it executes a creative direction that is already set. That decision is the part that cannot be automated.',
    'tell-note': 'On labelling: <strong>everything we produce is AI-generated content</strong>, and we hand it over documented as such. If your market requires you to declare it, you already have it in writing. What you tell your audience is your call, with every fact on the table.',
    'form-alt': 'Would you rather write to us directly?',
    'form-eyebrow': 'Free test',
    'form-title': 'Three photos with your product. <span class="glow-word">free</span>',
    'form-sub': 'All we need is your brand\'s Instagram. Andrés or Saúl replies personally, within 24 working hours.',
    'form-brand-label': 'Your brand\'s Instagram or website',
    'form-brand-ph': '@yourbrand',
    'form-email-label': 'Your email',
    'form-email-ph': 'hello@yourbrand.com',
    'form-email-help': 'This is where we send the three photos.',
    'form-name-label': 'Your name',
    'form-name-ph': 'So we don\'t just write "hi"',
    'form-product-label': 'Any product in particular?',
    'form-product-label-pack': 'Link to the product we will produce',
    'form-product-ph-pack': 'https://yourbrand.com/product',
    'form-product-ph': 'If you don\'t name one, we\'ll pick the one that works best',
    'form-optional': 'optional',
    'form-brief-label': 'The creative direction you have in mind',
    'form-brief-ph': 'What you want to say, references you like, where it will run, when you need it…',
    'form-country-label': 'Country',
    'form-country-ph': 'Spain',
    'form-country-help': 'It tells us how VAT works on your invoice.',
    'err-country': 'Tell us the country: VAT depends on it.',
    'form-legal': 'By sending this you accept our <a href="../privacidad.html" target="_blank" rel="noopener">privacy policy</a>. We use your data to reply to you, and for nothing else.',
    'form-phone-label': 'Phone',
    'form-phone-opt': 'optional',
    'form-phone-ph': '+34 600 000 000',
    'form-phone-help': 'Only for what is urgent about your project. We do not make sales calls.',
    'form-prev': 'Back',
    'form-next': 'Next',
    'form-step-1': 'Your brand',
    'form-step-2': 'The idea',
    'form-step-3': 'Contact',
    'err-product': 'Give us the link to the product you want produced.',
    'err-phone': 'Check the phone number: a digit seems to be missing.',
    'err-name': 'Tell us who the invoice should be made out to.',
    'form-assets-nota': 'Got product photos or references? You do not need them here. We will tell you where to send them once you are done.',
    'form-assets-nota-pack': 'Product photos and references are not uploaded here: when you finish we give you the address to send them to.',
    'ty-assets-head': 'Send us your photos and references',
    'ty-assets-body': 'If you have product photos, references or a moodboard, send them here and we start sooner:',
    'ty-assets-body-pack': 'Write to this address with your product photos and any references. It is the only thing we still need to get going:',
    'ty-assets-fine': 'If you have nothing at hand, that is fine: we work from whatever is public on your profile.',
    'ty-assets-cta': 'Upload my files →',
    'form-submit': 'Get my three photos',
    /* ── "pack" face: opened by the starter-pack CTA (see CARAS_CTA). */
    'form-eyebrow-pack': 'Starter pack · €490',
    'form-title-pack': 'Book your <span class="glow-word">8-piece</span> pack',
    'form-sub-pack': 'Tell us where to look and we reply the same working day with what we will produce, the delivery date and the payment link. Andrés or Saúl writes to you, not a salesperson.',
    'form-email-help-pack': 'This is where we send the proposal and the payment link.',
    'form-quota-pack': 'Five business days of production from the moment you confirm. If you book the <strong>full Campaign</strong> within the next 30 days, the €490 comes off in full.',
    'form-submit-pack': 'Book my pack',
    'form-fine-pack': 'Nothing is charged now. You confirm after seeing what we will produce.',
    'ty-step1-p-pack': 'We look at your site and Instagram: product, palette and tone. That is where the concept for your 8 pieces comes from.',
    'ty-step2-h-pack': 'We send the proposal',
    'ty-step2-p-pack': 'What we will produce, the delivery date and the payment link. If we cannot clearly beat what you already have, we say so and charge nothing.',
    'ty-step3-h-pack': 'Delivered in 5 days',
    'ty-step3-p-pack': 'From the moment you confirm: 8 pieces with one round of adjustments included.',
    'form-sending': 'Sending…',
    'form-fine': 'No card, no commitment. The photos are yours whether you hire us or not.',
    'form-quota': 'We take on <strong>4 brands a month</strong>. We look at each one before saying yes, and if we are not sure we tell you the same day.',
    'err-brand': 'We need this to see your product. An @ or a web address works.',
    'err-email': 'Check the email, something looks missing.',
    'form-error': 'We could not send it. Write to us and you will get the same fast reply:',
    'form-mailto': 'We have opened your email client with everything filled in: just hit send.',
    'form-mailto-link': 'Open it again',
    'formatos-sub': 'Five formats, one creative direction. From brand film to the vertical reel that looks shot on a phone.',
    'band2-text': 'Tell us what brand you run and we will tell you what we would do with it.',
    'band2-small': 'Twenty minutes on video with Andrés or Saúl. You leave with a concrete idea of what we would do with your brand.',
    'band2-btn': 'Tell us what brand you run →',
    'mob-cta': 'Get your free test',
    'mob-cta-note': '3 photos for your brand · no commitment',
    'trial-eyebrow': 'Before you pay anything',
    'trial-h2': 'TRY IT ON YOUR OWN <span class="glow-word">brand</span>',
    'trial-lead': 'Check it on your own product. <strong>Three photos, in 72 hours, free.</strong>',
    'trial-1-h': 'You give us your Instagram',
    'trial-1-p': 'Nothing else. No photos, no brief, no call.',
    'trial-2-h': 'We direct and produce',
    'trial-2-p': 'A concept for your brand and three photos that develop it: same light, same world.',
    'trial-3-h': 'You get them in 72 hours',
    'trial-3-p': 'Ready to publish. Yours, whether you hire us or not.',
    'trial-why': '<strong>Why free?</strong> Because showing you your own product convinces more than anything we could write here. It costs us half a day. If it works, we gain a client; if it does not, you keep the photos. We only take on <strong>4 new brands a month</strong>, and only if we can clearly beat what they already have — no waiting list: if you have a drop or a dated campaign, the sooner you tell us, the sooner it starts.',
    'trial-cta': 'Start your trial now',
    'trial-fine': 'No card · no commitment',
    'faq-q8': 'Is there a catch to the free test?',
    'faq-a8': '<p>No. We do not ask for a card, there is no subscription that kicks in later and you commit to nothing. You get <strong>three photos produced with your product</strong> and they are yours even if you never write back.</p><p>We do it because we are a new studio: it pays off better to show you the level with your own brand than to try to convince you in writing. You get publishable content; we get a case to show. All we ask for is your site or your Instagram.</p><p>If the photos convince you, we talk about the full campaign. If not, that is fine too: no follow-up, no mailing list.</p>',
    'faq-q10': 'Can I talk to someone before deciding?',
    'faq-a10': 'Yes. Book a 20-minute call with whoever will direct your project, not a salesperson. We show you examples close to your sector and answer questions before you ask for anything — you do not need to go through the free test first. You do not leave that call with an off-the-cuff price: once we understand what you need, we send you the written proposal, with the scope and the price closed.',
    'faq-q11': 'Can two people really sustain continuous production?',
    'faq-a11': 'Yes, and the reason is the same one that makes the price make sense: the first month we set up the concept and style for your brand; from the second month on, every delivery builds on that instead of starting from zero. They are not new concepts every month — they are variations on one already defined, and that is what makes the pace sustainable. That is also why Always-On is not sold by piece count: the volume that comes out of a concept already set up is not the same as starting from scratch, and we would rather agree it with you than print a number on a card.',
    'formatos-eyebrow': 'Video',
    'formatos-h2': 'A FORMAT FOR<br>EVERY CAMPAIGN',
    'vid-cat-1': 'Campaign editorial',
    'vid-title-1': 'Editorial film',
    'vid-desc-1': 'Motion with the language of a fashion editorial: measured pace, careful composition and a direction that carries the brand without shouting.',
    'vid-cat-2': 'Campaign editorial',
    'vid-title-2': 'Ad campaign',
    'vid-desc-2': 'Several variants of the same creative, generated at AI speed to test directions without waiting weeks for production.',
    'vid-cat-3': 'Product / E-commerce',
    'vid-title-3': 'Product film',
    'vid-desc-3': 'Detail shots for premium product: the texture, the shine and the weight of the object, in motion.',
    'vid-cat-4': 'UGC avatars',
    'vid-title-4': 'UGC Avatar',
    'vid-desc-4': 'Hyper-realistic avatars presenting your product in vertical, with the ease of real content and not of an ad.',
    'vid-cat-5': 'Campaign editorial',
    'vid-title-5': 'Cinematic campaign',
    'vid-desc-5': 'Fluid motion, atmosphere and large-format production scale.',
    'why-eyebrow': 'Before you see the price',
    'why-h2': 'WHY <span class="glow-word">WORLDWORK</span>',
    'why-sub': 'For brands that have already outgrown the photos they take of themselves. Everyone has the same tools — the difference is who decides what to generate.',
    'diff-typed-1': 'AN ASSET BANK, NOT ONE LOOSE VIDEO',
    'diff-desc-1': 'You walk away with every piece already cut to every format you need, not a single file you have to adapt yourself afterwards.',
    'diff-typed-3': 'BUILT TO SELL',
    'diff-desc-3': 'Every piece ships in the formats and ratios your ads manager is going to ask for on Monday.',
    'diff-typed-5': 'FROM WEEKS TO DAYS',
    'diff-desc-5': 'What others take five weeks to deliver, we deliver in five days. Every one of those weeks is another week advertising the same content.',
    'diff-typed-6': '10 VARIANTS WHERE OTHERS MAKE ONE',
    'diff-desc-6': 'You test ten directions in the time it used to take to produce one.',
    /* 'why-tagline' retired — see the Spanish dictionary. */
    'pre-ai-eyebrow': 'Before AI',
    'pre-ai-text': 'This is what we were directing before AI generated a single image: fashion shoots, fashion film, brand direction. It is not history — it is why we know which light, which framing and which gesture make a generated piece stop looking generated. An image generator does not have that archive behind it. We do — and it is what makes your brand look like it has a studio behind it, not a subscription.',
    'faq-eyebrow': 'Frequently asked questions',
    'faq-sub': 'Before you see what you can book, here is what we get asked the most.',
    'faq-q1': 'Are the images or videos created by WORLDWORK made with AI?',
    'faq-a1': '<p>Yes, and we say it plainly: <strong>the image is generated with AI</strong>. What is not generated is the decision. Creative direction, shot selection and final retouching —hands, textures, logos, the fall of a fabric— we do ourselves, by hand and piece by piece.</p><p>Generative production with human direction, review and post: that is what delivers scene consistency, real texture and faithful lighting in a fraction of the time and cost of a studio session.</p>',
    'faq-q9': 'Will my product look exactly like it does in real life?',
    'faq-a9': '<p>It is the right question, and the answer depends on the stage.</p><p>In the <strong>free test</strong> we work only from what is public on your Instagram: the product comes out recognisable, but it is a sample of direction and level, not a product listing shot.</p><p>In a <strong>real project</strong> we work from your actual photos and references. The product is not invented: it is recomposed into a new scene. Where the reference is demanding —a piece of jewellery, packaging with typography, a logo— we check and correct every image by hand against the original, and that check is part of the delivery, not an extra.</p><p>And if we can see we cannot guarantee the fidelity your product needs, we tell you before we start instead of handing you something approximate.</p>',
    'faq-q3': 'What sets WORLDWORK apart from a traditional agency, another AI studio, or doing it myself?',
    'faq-a3': '<p>With an agency you pay for hours: photographer, model, stylist, location and post-production, and out of all that comes <strong>one</strong> creative direction. If it does not work in ads, you start again and pay again.</p><p>Anyone can generate content with AI today, including you — the tool is no longer the difference. What changes with us is the trained eye behind it: we know what makes a generated image read as real instead of AI-looking — light, proportions, texture — and we hand-retouch what the model does not resolve on its own.</p><p>We close a brand brief with you before generating anything, produce ten variants of the same concept and deliver them in the formats your ads manager needs. In five days, and for less than the photographer alone costs.</p><p>And it does not depend on you sitting down to produce between meetings: it is our full-time job.</p>',
    'faq-q12': 'How does payment work?',
    'faq-a12': 'An initial deposit reserves production. Before generating anything we propose several creative concepts within the approved brief and you choose the one that convinces you most. You pay the rest only once the final delivery is complete and in your hands — not before.',
    'faq-q5': 'How many phases does the service include and who keeps the rights?',
    'faq-a5': '<p>It includes five phases from request to final delivery.</p><p><strong>PHASE 1:</strong> We start by thoroughly analyzing your brand: visual references, competition, what works and what doesn\'t.</p><p><strong>PHASE 2:</strong> From there we build a creative brief that you define and approve before we touch anything. No closed brief means no production, and that protects both of us.</p><p><strong>PHASE 3:</strong> Production. We work straight through, with no status meetings that add nothing: the brief is already closed. If anything changes the direction, we tell you that same day. For everything else, the next time you hear from us is with the full delivery in hand.</p><p><strong>PHASE 4:</strong> When it\'s ready, you receive the full first delivery. You have 48 hours to consolidate all comments and we make adjustments in a single round. And if the delivery does not meet the brief you approved in Phase 2, we redo it entirely at no cost and with no argument — the only condition is that the disagreement is with that brief, not with a later change of direction, which is a new campaign.</p><p><strong>PHASE 5:</strong> Final delivery already cropped to what you need: <strong>1:1 and 4:5</strong> for Meta, <strong>9:16</strong> for Reels and TikTok, and the long version for your Shopify or Amazon listing. Full commercial license from that moment.</p><p>No royalties, no restrictions, no fine print. The assets are yours <strong>FOREVER</strong>.</p>',
    'faq-q6': 'What type of brands do you work with?',
    'faq-a6': 'Fashion, cosmetics, jewellery and e-commerce above all. That is where our eye is trained and where we will beat your current alternative. If your brand sits outside those sectors, write to us anyway, but we only take the project on if we are confident we can do it better than whoever is doing it now.',
    'cta-h2': 'BOOK YOUR <span class="glow-word" id="cta-month">SEPTEMBER</span> CAMPAIGN',
    'cta-sub': '24 pieces in five days for €1,200. We take four brands a month: tell us about yours in twenty minutes and we will send you the written proposal.',
    'cta-btn1': 'Book my campaign →',
    'cta-alt': 'Rather see it first? Ask for your 3 free photos →',
    'meses': ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER'],
    'cta-btn2': 'View portfolio',
    'ticker-1': 'CAMPAIGN EDITORIAL', 'ticker-2': 'PRODUCT / E-COMMERCE', 'ticker-3': 'UGC AVATARS',
    'gal-eyebrow': 'Gallery',
    'gal-h2': 'THIS IS WHAT WE DELIVER IN <span class="glow-word">FIVE DAYS</span>',
    'gal-more': 'Expand gallery →',
    'gal-more-again': 'See another selection →',
    'footer-svc-1': 'Campaign editorial', 'footer-svc-2': 'Product / E-commerce', 'footer-svc-3': 'UGC avatars',
    'footer-tagline': 'Fashion campaigns in 5 days. No studio, no waiting list.',
    'footer-col-1': 'Services',
    'footer-col-2': 'Contact',
    'footer-col-3': 'Legal',
    'footer-copy': '© 2026 WORLDWORK Studio. All rights reserved.',
    'footer-location': 'MURCIA, SPAIN · GLOBAL REACH',
    'cta-mono-tagline': 'WORLDWORK · AI CONTENT STUDIO · MURCIA',
    'skip-link': 'Skip to content',
    'ty-eyebrow': 'Request received',
    'ty-title': 'THANK YOU FOR<br>TRUSTING <span>WORLD<span class="ty-work">WORK</span></span>',
    'ty-sub': 'We have received your request. Andrés or Saúl reads it personally. No filters, no middlemen. You will hear back within 24 working hours.',
    'ty-step1-h': 'We analyse your brand',
    'ty-step1-p': 'We look at your site and Instagram: product, palette and tone. That is where your test concept comes from.',
    'ty-step2-h': 'We confirm',
    'ty-step2-p': 'We tell you whether we take it on and what we will produce. If we are not sure, we say so plainly.',
    'ty-step3-h': 'Photos in 72h',
    'ty-step3-p': 'You get your three photos in full resolution, cut for Instagram. No cost, no obligation to continue.',
    'ty-btn1': 'Back to home →',
    'ty-btn2': 'See our work →',
  }
};

function applyTranslations(lang) {
  const t = TRANSLATIONS[lang];
  /* nav (desktop + móvil) por clave explícita, no por índice: antes reordenar un
     enlace rompía las traducciones en silencio, sin error ni aviso. */
  document.querySelectorAll('#navpill a[data-i18n],.mob-nav-link[data-i18n]').forEach(a=>{
    const v = t[a.dataset.i18n];
    if(v) a.textContent = v;
  });
  document.querySelector('.nav-cta').textContent = t['nav-cta'];
  const mobCta = document.querySelector('.mob-drawer-cta a');
  if(mobCta) mobCta.textContent = t['nav-cta'];
  // bandas CTA y barra móvil (no se traducían: quedaban en español)
  [1,2].forEach(i=>{
    const txt=document.getElementById('cta-band-'+i+'-text');
    const btn=document.getElementById('cta-band-'+i+'-btn');
    if(txt && t['band'+i+'-text']) txt.innerHTML = t['band'+i+'-text']+' <small>'+t['band'+i+'-small']+'</small>';
    if(btn && t['band'+i+'-btn']) btn.textContent = t['band'+i+'-btn'];
  });
  const mobBarLink=document.querySelector('.mob-cta-bar a');
  if(mobBarLink && t['mob-cta']) mobBarLink.textContent = t['mob-cta'];
  const mobNote=document.getElementById('mob-cta-note');
  if(mobNote && t['mob-cta-note']) mobNote.textContent = t['mob-cta-note'];
  // prueba gratis
  const trial = document.getElementById('prueba');
  if(trial){
    trial.querySelector('.section-eyebrow').textContent = t['trial-eyebrow'];
    trial.querySelector('.section-h2').innerHTML = t['trial-h2'];
    document.getElementById('trial-lead').innerHTML = t['trial-lead'];
    trial.querySelectorAll('.trial-step').forEach((it,i)=>{
      const h=t['trial-'+(i+1)+'-h'], p=t['trial-'+(i+1)+'-p'];
      if(h) it.querySelector('h3').textContent=h;
      if(p) it.querySelector('p').textContent=p;
    });
    document.getElementById('trial-why').innerHTML = t['trial-why'];
    document.getElementById('trial-cta').textContent = t['trial-cta'];
    document.getElementById('trial-fine').textContent = t['trial-fine'];
  }
  // servicios
  const svc = document.getElementById('servicios');
  if(svc){
    /* Por id, no por querySelector genérico: la sección tiene ahora dos
       .section-eyebrow (la cabecera y la de la comparativa) y dos titulares, así
       que un querySelector posicional pisaría el equivocado en cuanto se reordene. */
    const svcEyebrow = document.getElementById('svc-eyebrow-text');
    if(svcEyebrow && t['svc-eyebrow']) svcEyebrow.textContent = t['svc-eyebrow'];
    const svcH2 = svc.querySelector('.svc-head .section-h2');
    if(svcH2 && t['svc-h2']) svcH2.innerHTML = t['svc-h2'];
    const svcSub = svc.querySelector('.svc-sub');
    if(svcSub && t['svc-sub']) svcSub.textContent = t['svc-sub'];
    /* .btn-liquid escribe directo sobre el <a>, sin <span> interior — a diferencia
       de .btn-metal, que sí lo necesita para su estilo. */
    const svcFootBtn = document.getElementById('svc-foot-btn');
    if(svcFootBtn) svcFootBtn.textContent = t['svc-btn'];
    /* los dos CTA de contorno de las tarjetas laterales sí llevan <span> dentro */
    svc.querySelectorAll('.price-cta.btn-metal span').forEach((s,i)=>{
      const v = t['price-cta-'+i];
      if(v) s.textContent = v;
    });
  }
  /* enlaces de paso de la escalera de CTAs */
  /* El enlace de agenda ya no está en el hero; la clave se conserva en el diccionario
     por si vuelve. La guarda hace que esto sea inofensivo mientras no exista. */
  const heroAlt = document.getElementById('hero-alt');
  if(heroAlt && t['hero-alt']) heroAlt.textContent = t['hero-alt'];
  /* sección "antes de la IA": el h2 lleva <span> dentro, así que va por innerHTML;
     las tres listas van por índice porque son arrays paralelos del propio
     diccionario, no elementos reordenables del marcado. */
  const archH2 = document.getElementById('arch-h2');
  if(archH2 && t['arch-h2']) archH2.innerHTML = t['arch-h2'];
  const archCraft = document.getElementById('arch-craft');
  if(archCraft && t['arch-craft']) archCraft.textContent = t['arch-craft'];
  ['arch-eyebrow','arch-lead','arch-note','arch-next'].forEach(id=>{
    const el = document.getElementById(id);
    if(el && t[id]) el.textContent = t[id];
  });
  if(Array.isArray(t['arch-creds'])){
    document.querySelectorAll('#arch-creds li').forEach((li,i)=>{ if(t['arch-creds'][i]) li.textContent = t['arch-creds'][i]; });
  }
  if(Array.isArray(t['arch-cap'])){
    document.querySelectorAll('.archive-cap').forEach((el,i)=>{ if(t['arch-cap'][i]) el.textContent = t['arch-cap'][i]; });
  }
  const formatosNext = document.getElementById('formatos-next');
  if(formatosNext && t['formatos-next']) formatosNext.textContent = t['formatos-next'];
  const workNext = document.getElementById('work-next');
  if(workNext && t['work-next']) workNext.textContent = t['work-next'];
  const trialAlt = document.getElementById('trial-alt');
  if(trialAlt && t['trial-alt']) trialAlt.textContent = t['trial-alt'];
  // hero (guarda por si algún día este script sirve una página sin sección hero)
  const heroEyebrow = document.querySelector('.hero-eyebrow span:last-child');
  if(heroEyebrow) heroEyebrow.textContent = t['hero-eyebrow'];
  const heroSub = document.querySelector('.hero-sub');
  if(heroSub) heroSub.textContent = t['hero-sub'];
  /* El H1 son ahora dos líneas fijas. hero-line1 se sigue seleccionando por clase
     porque es la primera .hero-static; la segunda lleva id propio. */
  const heroLine1 = document.querySelector('.hero-static');
  if(heroLine1 && t['hero-line1']) heroLine1.textContent = t['hero-line1'];
  const heroLine2 = document.getElementById('hero-line2');
  if(heroLine2 && t['hero-line2']) heroLine2.textContent = t['hero-line2'];
  // estados del formulario (rescate y fallo de carga)
  const setTxt = (id,key,html) => {
    const el = document.getElementById(id);
    if(el && t[key]) el[html ? 'innerHTML' : 'textContent'] = t[key];
  };
  setTxt('form-alt-text','form-alt');
  /* formulario nativo */
  setTxt('wwform-eyebrow','form-eyebrow');
  setTxt('wwform-title','form-title',true);
  setTxt('wwform-sub','form-sub');
  setTxt('ww-email-help','form-email-help');
  setTxt('wwform-fine','form-fine');
  setTxt('wwform-legal','form-legal',true);
  setTxt('wwform-quota','form-quota',true);
  const opt = t['form-optional'] ? ' <span class="wwopt">'+t['form-optional']+'</span>' : '';
  const etiqueta = (id,clave,opcional) => {
    const el = document.getElementById(id);
    if(el && t[clave]) el.innerHTML = t[clave] + (opcional ? opt : '');
  };
  etiqueta('ww-brand-label','form-brand-label');
  etiqueta('ww-email-label','form-email-label');
  etiqueta('ww-name-label','form-name-label',true);
  etiqueta('ww-product-label','form-product-label',true);
  const ph = (id,clave) => { const el=document.getElementById(id); if(el&&t[clave]) el.placeholder = t[clave]; };
  ph('ww-brand','form-brand-ph');
  ph('ww-email','form-email-ph');
  /* bloque opcional de brief y referencias */
  etiqueta('ww-brief-label','form-brief-label');
  etiqueta('ww-phone-label','form-phone-label',true);
  etiqueta('ww-country-label','form-country-label');
  setTxt('ww-phone-help','form-phone-help');
  setTxt('ww-country-help','form-country-help');
  setTxt('ww-brief-opt','form-optional');
  setTxt('ww-prev-txt','form-prev');
  setTxt('ww-next-txt','form-next');
  setTxt('ww-step-1','form-step-1');
  setTxt('ww-step-2','form-step-2');
  setTxt('ww-step-3','form-step-3');
  ph('ww-phone','form-phone-ph');
  ph('ww-country','form-country-ph');
  ph('ww-brief','form-brief-ph');
  ph('ww-name','form-name-ph');
  ph('ww-product','form-product-ph');
  /* si había un error pintado, se repinta en el idioma nuevo */
  if(window._wwResetFormState) window._wwResetFormState();
  // garantía (puede aparecer en varios sitios)
  document.querySelectorAll('#guarantee-hero-text, #guarantee-cta-text').forEach(el => { if(t['guarantee']) el.innerHTML = t['guarantee']; });
  const heroRecip = document.getElementById('hero-recip');
  if(heroRecip && t['hero-recip']) heroRecip.innerHTML = t['hero-recip'];
  // ¿se nota que es IA?
  const tell = document.getElementById('se-nota');
  if(tell){
    tell.querySelector('.section-eyebrow').textContent = t['tell-eyebrow'];
    tell.querySelector('.section-h2').innerHTML = t['tell-h2'];
    document.getElementById('tell-lead').innerHTML = t['tell-lead'];
    tell.querySelectorAll('.tell-item').forEach((it,i)=>{
      const h = t['tell-'+(i+1)+'-h'], p = t['tell-'+(i+1)+'-p'];
      if(h) it.querySelector('h3').textContent = h;
      if(p) it.querySelector('p').textContent = p;
    });
    document.getElementById('tell-note-text').innerHTML = t['tell-note'];
  }
  /* ambos botones del hero envuelven su texto en un <span> (btn-metal): escribir
     textContent directamente sobre el <a> destruiría ese span y el estilo. */
  const heroActions = document.querySelectorAll('.hero-actions a');
  if(heroActions[0]) heroActions[0].querySelector('span').textContent = t['hero-btn1'];
  if(heroActions[1]) heroActions[1].querySelector('span').textContent = t['hero-btn2'];
  // stats
  /* precios y tabla comparativa: sustituyen a la antigua sección de estadísticas */
  const pon = (id,clave,html)=>{ const el=document.getElementById(id); if(el&&t[clave]) el[html?'innerHTML':'textContent']=t[clave]; };
  ['0','1','2'].forEach(n=>{
    pon('price-'+n+'-tag','price-'+n+'-tag');
    pon('price-'+n+'-num','price-'+n+'-num',true);
    pon('price-'+n+'-desc','price-'+n+'-desc');
  });
  /* solo la Campaña completa conserva una lista de diferenciadores — Arranque y
     Always-On se resolvieron a una frase de crédito/recurrencia, sin bullets. */
  /* Los tres inventarios se repintan desde su array: el número de líneas cambia
     entre idiomas y por plan, así que nada puede depender de la posición. */
  ['0','1','2'].forEach(n=>{
    const lista = document.getElementById('price-'+n+'-list'), puntos = t['price-'+n+'-list'];
    if(lista && Array.isArray(puntos)){
      lista.textContent = '';
      puntos.forEach(p=>{ const li=document.createElement('li'); li.textContent=p; lista.appendChild(li); });
    }
    /* innerHTML: la línea de posicionamiento del Pack lleva un <strong> de rótulo
       ("Prueba de capacidad.") y con textContent se perdería el marcado. */
    pon('price-'+n+'-pos','price-'+n+'-pos',true);
  });
  pon('svc-piece-def','svc-piece-def');
  pon('svc-band-head','svc-band-head');
  pon('svc-band-text','svc-band-text');
  pon('svc-band-head-2','svc-band-head-2');
  pon('svc-band-head-3','svc-band-head-3');
  pon('svc-result-head','svc-result-head');
  pon('svc-result-text','svc-result-text');
  pon('svc-result-label','svc-result-label');
  pon('price-0-credit','price-0-credit',true);
  pon('price-1-founders','price-1-founders',true);
  pon('price-2-note','price-2-note',true);
  pon('pricing-alt','pricing-alt');
  pon('pricing-alt-note','pricing-alt-note');
  pon('cmp-alt-intro','cmp-alt-intro',true);
  /* cmp-note fuera: era la nota que hacía auditable la cifra de 5.100 €, y esa cifra
     ya no está en la tabla. La comparación quedó en capacidades; el precio se entiende
     desde la oferta, no desde un "somos más baratos" que invita a preguntar qué falta. */
  /* desglose compacto + comparativa: cada celda traducible lleva su clave en data-k */
  document.querySelectorAll('.cmp-col [data-k]').forEach(el=>{
    const v = t['cmp-'+el.dataset.k];
    if(v) el.textContent = v;
  });
  // formatos
  const fmtSection = document.getElementById('formatos');
  if(fmtSection) {
    fmtSection.querySelector('.section-eyebrow').textContent = t['formatos-eyebrow'];
    fmtSection.querySelector('.section-h2').innerHTML = t['formatos-h2'];
    const fmtSub = document.getElementById('formatos-sub');
    /* innerHTML, no textContent: por si el subtítulo lleva marcado en línea. */
    if(fmtSub && t['formatos-sub']) fmtSub.innerHTML = t['formatos-sub'];
    /* cada tarjeta ya declara su data-idx: se traduce por ese índice en lugar de
       mantener a mano una lista de 10 entradas duplicadas que había que reordenar
       cada vez que cambiaba el carrusel. */
    fmtSection.querySelectorAll('.vid-card').forEach(card=>{
      const k = Number(card.dataset.idx) + 1;
      const cat = card.querySelector('.vid-cat');
      const ti  = card.querySelector('.vid-info h3');
      const d   = card.querySelector('.vid-desc');
      if(cat && t['vid-cat-'+k])   cat.textContent = t['vid-cat-'+k];
      if(ti  && t['vid-title-'+k]) ti.textContent  = t['vid-title-'+k];
      if(d   && t['vid-desc-'+k])  d.textContent   = t['vid-desc-'+k];
    });
  }
  // why section
  const whySection = document.querySelector('.why-section');
  if(whySection) {
    whySection.querySelector('.section-eyebrow').textContent = t['why-eyebrow'];
    whySection.querySelector('.section-h2').innerHTML = t['why-h2'];
    whySection.querySelector('.why-subtitle').textContent = t['why-sub'];
    /* .why-tagline retirada del marcado (ver comentario en index.html). Sin este
       querySelector envuelto, cambiar de idioma lanzaría sobre null y dejaría a medias
       todas las traducciones posteriores de la sección. */
    /* por clave (data-diff), no por índice: los diferenciadores están ordenados por
       fuerza del argumento y no por número, así que un array posicional habría
       aplicado los seis textos cruzados sin dar ningún error. */
    whySection.querySelectorAll('.diff-item[data-diff]').forEach(el=>{
      const k = el.dataset.diff;
      const kTyped = 'diff-typed-'+k, kDesc = 'diff-desc-'+k;
      if(!t[kTyped]) return;
      el.dataset.typed = t[kTyped];
      const descEl = el.querySelector('.diff-desc');
      if(descEl && t[kDesc]) descEl.textContent = t[kDesc];
      // update already-typed text, rebuilding the accent highlight for the current language
      const typedEl = el.querySelector('.typed-text');
      if(typedEl && typedEl.textContent){
        const newText = t[kTyped];
        const accentWord = lang === 'en' ? (el.dataset.accentEn || '') : (el.dataset.accent || '');
        if(accentWord && newText.indexOf(accentWord) !== -1){
          const parts = newText.split(accentWord);
          typedEl.innerHTML = parts[0]+'<span class="typed-accent">'+accentWord+'</span>'+parts.slice(1).join(accentWord);
        } else {
          typedEl.textContent = newText;
        }
      }
    });
  }
  // team
  // faq
  const faqSection = document.querySelector('.faq-section');
  if(faqSection) {
    faqSection.querySelector('.section-eyebrow').textContent = t['faq-eyebrow'];
    const faqSub = document.getElementById('faq-sub');
    if(faqSub && t['faq-sub']) faqSub.textContent = t['faq-sub'];
    /* cada .faq-item declara su clave: insertar o reordenar una pregunta ya no
       descoloca las traducciones de todas las siguientes. data-rich marca las
       respuestas que ya traen su propio marcado <p>. */
    faqSection.querySelectorAll('.faq-item[data-faq]').forEach(item=>{
      const k = item.dataset.faq;
      const q = item.querySelector('.faq-question');
      const ans = item.querySelector('.faq-answer');
      const qv = t['faq-q'+k], av = t['faq-a'+k];
      if(q && qv){
        const icon = q.querySelector('.faq-icon');
        q.innerHTML = qv + ' ' + (icon ? icon.outerHTML : '');
      }
      if(ans && av){
        ans.innerHTML = item.hasAttribute('data-rich') ? av : '<p>' + av + '</p>';
        if(item.classList.contains('open')) ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  }
  // cta
  const ctaSection = document.querySelector('.cta-section');
  if(ctaSection) {
    ctaSection.querySelector('.cta-h2').innerHTML = t['cta-h2'];
    ctaSection.querySelector('.cta-sub').textContent = t['cta-sub'];
    /* Selección por clase y no por [data-form-open]: el primario del cierre pasó a ser
       la campaña (data-agenda) y la prueba bajó a .cta-alt, que sí lleva
       data-form-open. Con el selector anterior, el botón principal se quedaba sin
       traducir y el enlace de escape recibía el texto del botón. */
    const ctaBtn1 = ctaSection.querySelector('.cta-actions .btn-liquid');
    if(ctaBtn1 && t['cta-btn1']) ctaBtn1.textContent = t['cta-btn1'];
    const ctaAlt = document.getElementById('cta-alt');
    if(ctaAlt && t['cta-alt']) ctaAlt.textContent = t['cta-alt'];
    const pb2=document.getElementById('btn-portfolio-cta');
    if(pb2) pb2.querySelector('span').textContent = t['cta-btn2'];
  }
  // footer
  document.querySelector('.footer-tagline').textContent = t['footer-tagline'];
  /* enlaces de servicio del pie y ticker: los dos se quedaban en español al pasar a EN.
     En el ticker hay que reescribir además dataset.final, porque el efecto scramble
     cachea ahí el texto al arrancar y en el siguiente ciclo lo devolvería al anterior. */
  document.querySelectorAll('.footer-links a[data-fk]').forEach(a=>{
    const v = t['footer-svc-'+a.dataset.fk];
    if(v) a.textContent = v;
  });
  document.querySelectorAll('[data-scramble][data-tk]').forEach(el=>{
    const v = t['ticker-'+el.dataset.tk];
    if(v){ el.textContent = v; el.dataset.final = v; }
  });
  /* #trabajo: por clave explícita en data-wk, nunca por índice — cada bloque de campaña
     lleva su prefijo (ed01-, pr01-, ed02-) y el orden en el DOM da igual. innerHTML
     porque el titular lleva el <span class="glow-word"> dentro. */
  document.querySelectorAll('[data-wk]').forEach(el=>{
    const v = t[el.dataset.wk];
    if(v) el.innerHTML = v;
  });
  /* los títulos de columna tenían clave en el diccionario pero nadie los aplicaba:
     en inglés el footer seguía en español. */
  document.querySelectorAll('.footer-col-title').forEach((el,i)=>{
    const v = t['footer-col-'+(i+1)];
    if(v) el.textContent = v;
  });
  document.querySelector('.footer-bottom span').textContent = t['footer-copy'];
  const footerLoc = document.getElementById('footer-location');
  if(footerLoc) footerLoc.textContent = t['footer-location'];
  const ctaTagline = document.getElementById('cta-mono-tagline');
  if(ctaTagline) ctaTagline.textContent = t['cta-mono-tagline'];
  const skipLink = document.getElementById('skip-link');
  if(skipLink) skipLink.textContent = t['skip-link'];
  // thank you modal
  document.querySelector('.ty-eyebrow span:last-child').textContent = t['ty-eyebrow'];
  document.querySelector('.ty-title').innerHTML = t['ty-title'];
  document.querySelector('.ty-sub').textContent = t['ty-sub'];
  const tySteps = document.querySelectorAll('.ty-step');
  if(tySteps[0]){ tySteps[0].querySelector('h4').textContent=t['ty-step1-h']; tySteps[0].querySelector('p').textContent=t['ty-step1-p']; }
  if(tySteps[1]){ tySteps[1].querySelector('h4').textContent=t['ty-step2-h']; tySteps[1].querySelector('p').textContent=t['ty-step2-p']; }
  if(tySteps[2]){ tySteps[2].querySelector('h4').textContent=t['ty-step3-h']; tySteps[2].querySelector('p').textContent=t['ty-step3-p']; }
  document.getElementById('ty-home').textContent = t['ty-btn1'];
  /* Escribía textContent sobre el <a>, lo que destruía el <span> interior — y
     .btn-metal estiliza ese span, no el enlace: el botón se quedaba sin borde ni
     fondo, dibujado como texto suelto. Además la guarda era autodestructiva
     (solo actuaba si el span existía, y al actuar lo borraba), así que a partir
     de la primera pasada el texto ya no volvía a traducirse nunca. */
  const tyWork = document.getElementById('ty-work-link');
  if(tyWork && t['ty-btn2']){
    const s = tyWork.querySelector('span');
    if(s) s.textContent = t['ty-btn2'];
    else tyWork.innerHTML = '<span>' + t['ty-btn2'] + '</span>';
  }
  /* ── el mes, en los dos sitios que lo nombran ──
     El titular del cierre y las plazas de la tarjeta de campaña llevan el mes ESCRITO
     en el HTML servido: así va completo para Google y para un lector de pantalla, y no
     depende de que el JS llegue. Esto solo lo corrige cuando el calendario avanza, de
     modo que ninguno de los dos caduca sin que nadie los toque.
     Va aquí, al final, y no junto a cada bloque: los dos nodos viven dentro de textos
     que se acaban de reescribir con innerHTML unas líneas más arriba, así que hay que
     volver a buscarlos — los del marcado original ya no existen.
     Regla: siempre el mes SIGUIENTE al actual. El del cierre va en versalitas dentro
     de un titular en mayúsculas; el de la tarjeta abre frase, así que se capitaliza —
     y así funciona igual en inglés, donde los meses siempre van en mayúscula inicial. */
  if(Array.isArray(t['meses'])){
    const nombreMes = t['meses'][(new Date().getMonth() + 1) % 12];
    const mesCta = document.getElementById('cta-month');
    if(mesCta) mesCta.textContent = nombreMes;
    const mesPrecio = document.getElementById('price-month');
    if(mesPrecio) mesPrecio.textContent = nombreMes.charAt(0) + nombreMes.slice(1).toLowerCase();
  }
  /* AL FINAL, siempre: todo lo de arriba acaba de pintar la cara por defecto sobre el
     formulario y la pantalla de gracias. Si hay una cara activa (el pack, por ejemplo)
     y el visitante cambia de idioma con el modal abierto, sin esto el modal volvería
     a "prueba gratis" en mitad de una reserva. */
  if(typeof aplicarCaraFormulario === 'function') aplicarCaraFormulario();
}

function setLang(lang, remember) {
  /* El idioma del documento se fija ANTES de traducir. Iba después, y cualquier
     código llamado desde applyTranslations que consulte documentElement.lang —el
     formulario nativo lo hace para elegir sus textos— leía todavía el idioma
     anterior y dejaba el botón de enviar en el idioma equivocado. */
  document.documentElement.lang = (lang === 'en') ? 'en' : 'es';
  if(lang === 'en') applyTranslations('en');
  else applyTranslations('es');
  if(window.wwRenderMotionLabel) window.wwRenderMotionLabel();
  if(window.wwRenderAgendaAviso) window.wwRenderAgendaAviso();
  if(remember !== false){
    try{ localStorage.setItem('ww-lang', lang); }catch(e){}
    /* solo si es elección explícita: la autodetección no es una decisión del visitante */
    if(window.wwTrack) wwTrack('idioma',{a:lang});
  }
  /* El portfolio autoalojado tiene su propio selector de idioma (ES/EN) en la propia
     página, así que el enlace es el mismo siempre — no hace falta un PDF distinto
     por idioma como antes. El secundario del hero sigue apuntando a #formatos, que
     es el portfolio en vídeo y no saca al visitante del sitio. */
  const pb2 = document.getElementById('btn-portfolio-cta');
  if(pb2){
    pb2.href = '/portfolio';
    pb2.target = '_blank';
  }
  const isEn = lang === 'en';
  /* conmutador permanente de nav y drawer: el popup de la esquina solo se ofrecía en
     la primera visita de un navegador no hispanohablante, así que a un visitante con
     el navegador en español la versión inglesa no le existía. */
  [['lang-sw-es',!isEn],['lang-sw-en',isEn],['mob-lang-es',!isEn],['mob-lang-en',isEn]]
    .forEach(([id,on])=>{ const el=document.getElementById(id); if(el) el.setAttribute('aria-pressed', on?'true':'false'); });
}

/* Los seis botones de idioma (popup, conmutador de nav, conmutador del drawer móvil,
   × dos idiomas) llevaban onclick="setLang(...)" inline. La CSP real (script-src sin
   'unsafe-inline', deliberado) bloquea eso — exactamente el mismo bug que ya se
   arregló una vez para la hoja de Google Fonts, aquí sin detectar hasta que el
   propietario probó los botones en el sitio desplegado. En local nunca se ve, porque
   el servidor de desarrollo no aplica _headers. */
[['lang-sw-es','es'],['lang-sw-en','en'],['mob-lang-es','es'],['mob-lang-en','en']]
  .forEach(([id,lang])=>{
    const el=document.getElementById(id);
    if(el) el.addEventListener('click', ()=>setLang(lang));
  });

/* ── idioma: recordar la elección y autodetectar en la primera visita ──
   Antes el popup se mostraba en cada carga, no guardaba nada y no miraba el idioma
   del navegador: interrumpía antes incluso de que el visitante supiera qué se vende. */
(function(){
  /* /en/index.html se sirve siempre en inglés, sea cual sea el navegador o una
     elección guardada de una visita anterior a la home en español: es una URL
     dedicada, no un destino del selector de idioma. */
  if(window.WW_FORCE_LANG){
    setLang(window.WW_FORCE_LANG, false);
    return;
  }
  let saved=null;
  try{ saved=localStorage.getItem('ww-lang'); }catch(e){}
  if(saved==='en'||saved==='es'){
    setLang(saved);                       // elección previa: se aplica y no se pregunta
    return;
  }
  const browserEs=(navigator.language||'es').toLowerCase().startsWith('es');
  if(browserEs){
    setLang('es', false);                 // ya está en español: no hay nada que preguntar
    return;
  }
  /* Navegador no hispanohablante: servimos EN y ya está. Antes se abría además un
     popup encima del hero ofreciendo cambiar de idioma — una interrupción en la
     primera visita, antes de que el visitante supiera qué se vende. El conmutador
     ES/EN del nav está siempre a la vista y hace el mismo trabajo sin interrumpir. */
  setLang('en', false);
})();

/* ── Page Visibility: skip RAF work when tab is hidden ── */
window._wwHidden=false;
document.addEventListener('visibilitychange',()=>{window._wwHidden=document.hidden;});

/* ── control global de movimiento (WCAG 2.2.2) ──
   Un único interruptor que detiene ticker, carrusel de vídeo y carrusel móvil.
   Arranca pausado si el sistema pide movimiento reducido. */
window._wwMotionPaused=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
(function(){
  const btn=document.getElementById('motion-toggle');
  const label=document.getElementById('motion-toggle-label');
  if(!btn||!label)return;
  function render(){
    btn.setAttribute('aria-pressed',String(window._wwMotionPaused));
    const en=document.documentElement.lang==='en';
    const texto=window._wwMotionPaused
      ? (en?'Resume motion':'Reanudar movimiento')
      : (en?'Pause motion':'Pausar movimiento');
    label.textContent=texto;
    /* El botón pasó a ser solo icono: title= es el tooltip que ve quien pasa el
       ratón, y tiene que decir lo mismo que el nombre accesible del span.sr-only,
       o un lector de pantalla y un usuario de ratón oirían/leerían cosas distintas. */
    btn.title=texto;
  }
  render();
  window.wwRenderMotionLabel=render; // setLang() lo llama para refrescar el idioma sin reabrir el toggle
  btn.addEventListener('click',()=>{window._wwMotionPaused=!window._wwMotionPaused;render();});
})();

/* Aquí había un bloque que, en móvil, seleccionaba los vídeos con preload="none" y
   les ponía preload="none". No hacía absolutamente nada, y su comentario ("para no
   cargar datos innecesarios") daba a entender que el consumo de datos en móvil estaba
   resuelto. No lo está: el carrusel arranca los diez <video> a la vez, unos 2,4 MB de
   previsualizaciones y diez decodificadores simultáneos. Eso se arregla limitando la
   reproducción a las tarjetas realmente visibles, no aquí. */

/* ── barra CTA fija móvil: aparece al pasar el hero, se oculta de nuevo al llegar al footer ──
   Antes solo escuchaba al hero: una vez pasado, "show" se quedaba para siempre y la barra
   flotaba encima del footer con apenas unos píxeles de margen real. */
(function(){
  const bar=document.getElementById('mob-cta-bar');
  const hero=document.getElementById('hero');
  const footerEl=document.querySelector('footer');
  if(!bar||!hero)return;
  let pastHero=false, nearFooter=false;
  function sync(){ bar.classList.toggle('show', pastHero && !nearFooter); }
  new IntersectionObserver(entries=>{
    entries.forEach(en=>{ pastHero=!en.isIntersecting; sync(); });
  },{threshold:0}).observe(hero);
  if(footerEl){
    new IntersectionObserver(entries=>{
      entries.forEach(en=>{ nearFooter=en.isIntersecting; sync(); });
    },{threshold:0,rootMargin:'0px 0px -20% 0px'}).observe(footerEl);
  }
})();

/* ── mobile nav drawer ── */
(function(){
  const toggle=document.getElementById('mob-toggle');
  const drawer=document.getElementById('mob-drawer');
  if(!toggle||!drawer)return;
  let isOpen=false;
  function open(){
    isOpen=true;
    drawer.classList.add('open');
    toggle.classList.add('open');
    toggle.setAttribute('aria-expanded','true');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('drawer-open');
    document.body.style.overflow='hidden';
  }
  function close(keepOverflow){
    isOpen=false;
    drawer.classList.remove('open');
    toggle.classList.remove('open');
    toggle.setAttribute('aria-expanded','false');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('drawer-open');
    if(!keepOverflow) document.body.style.overflow='';
  }
  toggle.addEventListener('click',()=>isOpen?close():open());
  drawer.querySelectorAll('a').forEach(a=>{
    a.addEventListener('click',e=>{
      const href=a.getAttribute('href');
      if(a.hasAttribute('data-form-open')){close(true);return;}
      if(href&&href.startsWith('#')&&href.length>1){
        e.preventDefault();
        close(false);
        setTimeout(()=>{
          const t=document.querySelector(href);
          if(t)t.scrollIntoView({behavior:'smooth'});
        },10);
        return;
      }
      close(false);
    });
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&isOpen)close();});
})();

/* ── work-block galleries: click a thumbnail to load it big, plus prev/next arrows ── */
(function(){
  document.querySelectorAll('.work-media-col').forEach(col=>{
    const mediaBox = col.querySelector('.work-media');
    const mainImg = mediaBox.querySelector('img');
    const thumbs = Array.from(col.querySelectorAll('.work-support img'));
    if(!mediaBox || !mainImg || !thumbs.length) return;

    /* La tira de miniaturas era FIJA: siempre las mismas tres, y la imagen de portada
       no aparecía en ninguna. Al pinchar una miniatura, la que estaba arriba
       desaparecía del bloque y solo se podía recuperar con las flechas — el visitante
       no tenía forma de saber que seguía ahí.
       Ahora hay una sola lista de piezas y las miniaturas muestran SIEMPRE las que no
       están en el hueco grande: al promover una, la anterior baja a la tira.
       Cada pieza declara sus dos proporciones en el marcado (4:5 para el hueco grande,
       1:1 para la miniatura), así que no se recorta dos veces ni se deriva ninguna URL
       por manipulación de cadenas. */
    /* Los bloques PR-01 y ED-02 siguen con marcado de placeholder y no declaran las dos
       proporciones. Sin estos respaldos, al promover una miniatura la portada bajaría
       con src vacío y se vería rota: si falta la versión pequeña se reutiliza la grande
       (object-fit la recorta) y al revés. */
    /* xl: versión de mayor resolución solo para el lightbox. Los bloques PR-01 y
       ED-02 (placeholder) no la declaran todavía, así que caen a "big" — se ve algo
       menos nítida ampliada del todo, pero nunca rota. */
    const items = [
      { big: mainImg.getAttribute('src'),
        bigSet: mainImg.getAttribute('srcset'),
        xl: mainImg.dataset.xl || mainImg.getAttribute('src'),
        small: mainImg.dataset.small || mainImg.getAttribute('src'),
        smallSet: mainImg.dataset.smallSrcset || '',
        alt: mainImg.getAttribute('alt') },
      ...thumbs.map(t => ({
        big: t.dataset.full || t.getAttribute('src'),
        bigSet: t.dataset.fullSrcset || '',
        xl: t.dataset.xl || t.dataset.full || t.getAttribute('src'),
        small: t.getAttribute('src'),
        smallSet: t.getAttribute('srcset'),
        alt: t.getAttribute('alt') }))
    ];
    let idx = 0;

    function apply(img, src, set, alt){
      img.setAttribute('src', src);
      if(set) img.setAttribute('srcset', set); else img.removeAttribute('srcset');
      img.setAttribute('alt', alt);
    }

    function render(){
      const it = items[idx];
      apply(mainImg, it.big, it.bigSet, it.alt);
      /* las demás, en orden, saltándose la que está arriba */
      const rest = items.filter((_,i) => i !== idx);
      thumbs.forEach((t,i) => {
        const o = rest[i];
        if(!o) return;
        apply(t, o.small, o.smallSet, o.alt);
        t.dataset.goto = items.indexOf(o);
      });
    }

    thumbs.forEach(t => {
      t.addEventListener('click', () => { idx = Number(t.dataset.goto); render(); });
    });

    /* Antes vivían dentro del recuadro de la foto (izquierda/derecha), y en móvil se
       comían buena parte de la imagen; sacarlas fuera del todo chocaba con el texto
       de al lado en desktop porque el hueco es más estrecho que el propio botón.
       Ahora van dentro de la fila de miniaturas, flanqueándolas: ni tapan la foto ni
       compiten con el texto. */
    const prevBtn=document.createElement('button');
    prevBtn.type='button'; prevBtn.className='work-arrow work-arrow-prev'; prevBtn.setAttribute('aria-label','Pieza anterior'); prevBtn.textContent='←';
    const nextBtn=document.createElement('button');
    nextBtn.type='button'; nextBtn.className='work-arrow work-arrow-next'; nextBtn.setAttribute('aria-label','Pieza siguiente'); nextBtn.textContent='→';
    const supportBox = col.querySelector('.work-support');
    supportBox.insertBefore(prevBtn, supportBox.firstChild);
    supportBox.appendChild(nextBtn);

    /* el lightbox es un único elemento global compartido por las tres galerías; este
       objeto le da acceso a la de este bloque para que sus flechas (y las de teclado)
       avancen la pieza correcta y dejen la galería de fondo sincronizada al cerrar. */
    function navGet(dir){
      idx = (idx + dir + items.length) % items.length;
      render();
      return { src: items[idx].xl, alt: items[idx].alt };
    }

    /* clic en la foto grande → ampliar, igual que los vídeos. role+tabindex a mano
       porque es un <img>, no un <button>; Enter/Espacio disparan el mismo click. */
    mainImg.setAttribute('role','button');
    mainImg.setAttribute('tabindex','0');
    mainImg.addEventListener('mouseenter',()=>cursor.classList.add('big'));
    mainImg.addEventListener('mouseleave',()=>cursor.classList.remove('big'));
    mainImg.addEventListener('click', ()=> openImgLightbox(items[idx].xl, items[idx].alt, mainImg, { get: navGet }));
    mainImg.addEventListener('keydown', e => {
      if(e.key==='Enter' || e.key===' '){ e.preventDefault(); mainImg.click(); }
    });
    prevBtn.addEventListener('click', ()=>{ idx=(idx-1+items.length)%items.length; render(); });
    nextBtn.addEventListener('click', ()=>{ idx=(idx+1)%items.length; render(); });

    render();
  });
})();

/* Los bloqueos anti-copia (contextmenu, selectstart, copy, F12/Ctrl+U/S/P) se han
   retirado: se saltaban con ver-código y solo penalizaban al visitante legítimo —
   impedían copiar el email de contacto, imprimir o guardar la propuesta en PDF para
   compartirla internamente, que es exactamente lo que hace un comprador B2B.
   Se conserva únicamente el bloqueo de arrastre de imágenes, que no rompe nada. */
document.addEventListener('dragstart',e=>{ if(e.target.tagName==='IMG')e.preventDefault(); });
